import {Project} from '../model/editor/Project';
import {CoverTheme} from "../model/editor/CoverTheme";
// import 'fabric';
import {CoverThemeItemSetting} from "../model/editor/CoverThemeItemSetting";
import {ColorPalette} from "../model/color/ColorPalette";
import {FontSettings} from "../model/editor/FontSettings";
import {ProjectSaver} from "../model/ProjectSaver";
import {Cover} from "../model/editor/Cover";

declare const fabric: any;

export class CanvasManager {
  project: Project;
  projectSaver: ProjectSaver;
  canvasElement: Element;

  SHEET_THICKNESS: number = 0.0047401;
  COVER_THICKNESS: number = 0.02;
  MIN_PAGES_FOR_SPINE_THICKNESS: number = 9;

  coverGridLines = true;
  backgroundObjectsSelectable = true;
  spineSizeForDesigner = false;

  canvas: any;
  screenPPI = 96;

  guidesAdded = false;

  // Values needed by the fabric canvas
  freeDrawingMode = 'Pencil';
  vLinePatternBrush;
  hLinePatternBrush;
  squarePatternBrush;
  diamondPatternBrush;
  texturePatternBrush;

  // The following seem unnecessary -- investigate and remove
  consoleSVGValue: string = (
    '<?xml version="1.0" standalone="no"?>' + '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">' + '<svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">' + '<rect width="300" height="100" style="fill:rgb(0,0,255);stroke-width:1;stroke:rgb(0,0,0)"/>' + '</svg>'
  );

  consoleValue: string = ( '// clear canvas\n' + 'canvas.clear();\n\n' + '// remove currently selected object\n' + 'canvas.remove(this.canvas.getActiveObject());\n\n' + '// add red rectangle\n' + 'canvas.add(new fabric.Rect({\n' + '  width: 50,\n' + '  height: 50,\n' + '  left: 50,\n' + '  top: 50,\n' + "  fill: 'rgb(255,0,0)'\n" + '}));\n\n' + '// add green, half-transparent circle\n' + 'canvas.add(new fabric.Circle({\n' + '  radius: 40,\n' + '  left: 50,\n' + '  top: 50,\n' + "  fill: 'rgb(0,255,0)',\n" + '  opacity: 0.5\n' + '}));');

  consoleJSONValue: string = (
    '{"objects":[{"type":"","originX":"left","originY":"top","left":-6.95,"top":-235.58,"width":720,"height":1080,"fill":"rgb(0,0,0)","stroke":null,"strokeWidth":0,"strokeDashArray":null,"strokeLineCap":"butt","strokeLineJoin":"miter","strokeMiterLimit":10,"scaleX":1.15,"scaleY":1.15,"angle":0.12,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"crossOrigin":"","alignX":"none","alignY":"none","meetOrSlice":"meet","src":"http://fabricjs.com/assets/pug.jpg","filters":[],"resizeFilters":[]},{"type":"i-text","originX":"center","originY":"center","left":348.51,"top":211.53,"width":214.02,"height":39.55,"fill":"#ffffff","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeLineJoin":"miter","strokeMiterLimit":10,"scaleX":0.5,"scaleY":0.5,"angle":270.05,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"title on Spine","fontSize":35,"fontWeight":"","fontFamily":"helvetica","fontStyle":"","lineHeight":1.16,"textDecoration":"","textAlign":"left","textBackgroundColor":"","charSpacing":0,"styles":{}},{"type":"text","originX":"left","originY":"top","left":427.64,"top":90.49,"width":581.09,"height":79.1,"fill":"#ffffff","stroke":null,"strokeWidth":1,"strokeDashArray":null,"strokeLineCap":"butt","strokeLineJoin":"miter","strokeMiterLimit":10,"scaleX":0.5,"scaleY":0.5,"angle":0.02,"flipX":false,"flipY":false,"opacity":1,"shadow":null,"visible":true,"clipTo":null,"backgroundColor":"","fillRule":"nonzero","globalCompositeOperation":"source-over","transformMatrix":null,"skewX":0,"skewY":0,"text":"title Text Here","fontSize":70,"fontWeight":"bold","fontFamily":"verdana","fontStyle":"","lineHeight":1.16,"textDecoration":"","textAlign":"left","textBackgroundColor":"","charSpacing":0}],"background":"#ffffff"}'
  );

  // End values needed by the fabric canvas


  constructor (project: Project, canvasElement: Element, projectSaver: ProjectSaver) {
    this.projectSaver = projectSaver;
    this.project = project;
    this.canvasElement = canvasElement;
    this.canvas = new fabric.Canvas('canvasElement', {
      width: 5000, height: 3000, preserveObjectStacking: true
    });
    // this.setPreserveObjectStacking(true);
  // , preserveObjectStacking: true, controlsAboveOverlay: true
  }

  getFabric() {
    return fabric;
  }


  async loadCover() {
    const this_: CanvasManager = this;
    return new Promise(function(resolve, reject) {
      if (this_.project.cover) {
        // if (!this_.project.cover.jsonContents) {
          // this_.project.cover.jsonContents = {objects: []};
        // }

        // this_.canvas.loadFromJSON(this_.project.cover.jsonContents, _ => {
        // Load empty and get the user input properties from the cover object and defaults from the theme
        this_.canvas.loadFromJSON({objects: []}, _ => {
          this_.canvas.selection = false;
          this_.canvas.renderAll();
          this_.removeCoverGuideLines();
          this_.addCoverGuideLines();
          this_.setCoverEditorDisplayWidth();
          if (this_.project.cover.coverTheme && this_.canvas) {
            this_.applyCoverTheme(this_.project.cover.coverTheme, false);
            this_.selectObjectBasedOnRole('font-title-1');
            this_.canvas.renderAll();
          }

          this_.initBrushes();
          this_.initCustomization();

          // this_.canvas.on('object:keydown', options => {
          //   if (this_.canvas && this_.project.cover) {
          //
          //   }
          // });
          // this_.canvas.on('canvas:keydown', options => {
          //   if (this_.canvas && this_.project.cover) {
          //
          //   }
          // });
          //
          // this_.canvas.on('object:added', options => {
          //   if (this_.projectSaver && this_.canvas && this_.project.cover) {
          //     this_.projectSaver.saveProjectAndCanvas(this_.project, this_.canvas);
          //   }
          // });

          this_.canvas.on('object:modified', options => {
            if (this_.projectSaver && this_.canvas && this_.project.cover) {
              const object = this_.canvas.getActiveObject();
              object.setCoords();
              if ( object && this_.getType() === 'textbox') {
                if (options.target.text === '') {
                  options.target.text = ' ';
                  options.target.notext = true;
                } else {
                  options.target.notext = false;
                }
                if (options.target.text === '') {
                  options.target.text = ' ';
                  options.target.notext = true;
                } else {
                  options.target.notext = false;
                }
                this_.setOverridePropertyString('text', options.target.text);
                this_.setOverridePropertyString('notext', options.target.notext);
                if (options.target.styles) {
                  this_.setOverridePropertyObject('textStyles', options.target.styles);
                } else {
                  //                this_.setOverridePropertyObject('textStyles', {});
                }

                this_.projectSaver.saveProjectAndCanvas(this_, this_.project, this_.canvas);
              }
            }
          });
          // this_.canvas.on('text:changed', options => {
          //   if (this_.projectSaver && this_.canvas && this_.project.cover) {
          //     if (options.target.text === '') {
          //       options.target.text = ' ';
          //       options.target.notext = true;
          //     } else {
          //       options.target.notext = false;
          //     }
          //     if (options.target.text === '') {
          //       options.target.text = ' ';
          //       options.target.notext = true;
          //     } else {
          //       options.target.notext = false;
          //     }
          //     this_.setOverridePropertyString('text', options.target.text);
          //     this_.setOverridePropertyString('notext', options.target.notext);
          //     if ( options.target.styles ) {
          //       this_.setOverridePropertyString('textStyles', options.target.styles);
          //     }
          //
          //     this_.projectSaver.saveProjectAndCanvas(this_.project, this_.canvas);
          //     canvas.log("text:changed event");
          //   }
          // });
          this_.canvas.on('object:moved', options => {
            if (this_.projectSaver && this_.canvas && this_.project.cover) {
              const object = this_.canvas.getActiveObject();
              if ( object && this_.getType() === 'image') {
                object.setCoords();
                const spineWidth = Number( this_.project.spineWidth.substring(0, this_.project.spineWidth.length - 2) );
                const scaledPPI = Number( this_.screenPPI * this_.project.cover.scale );
                const widthInInches = Number( this_.project.width.substring(0, this_.project.width.length - 2) );
                const heightInInches = Number( this_.project.height.substring(0, this_.project.height.length - 2) );
                let topImageDifferentRatioAdjustment = this_.getOverridePropertyNumber('topImageDifferentRatioAdjustment', undefined);
                topImageDifferentRatioAdjustment = topImageDifferentRatioAdjustment ? topImageDifferentRatioAdjustment : 0;
                let leftImageDifferentRatioAdjustment = this_.getOverridePropertyNumber('leftImageDifferentRatioAdjustment', undefined);
                leftImageDifferentRatioAdjustment = leftImageDifferentRatioAdjustment ? leftImageDifferentRatioAdjustment : 0;
                const coverWidth = ( widthInInches * 2 + spineWidth + 1) * scaledPPI;
                const coverHeight = ( heightInInches * 1 + 1) * scaledPPI;

                const top = object.top / this_.project.cover.scale;
                const left = object.left / this_.project.cover.scale;
                const width = object.width;
                const height = object.height;
                const scaleX = options.target.scaleX;
                const scaleY = options.target.scaleY;
                const topUnadjusted = object.topUnadjusted;
                const leftUnadjusted = object.leftUnadjusted;
                const horizontalAdjustment = Number((left - leftUnadjusted) / coverWidth) + leftImageDifferentRatioAdjustment;
                const verticalAdjustment = Number((top - topUnadjusted) / coverHeight) + topImageDifferentRatioAdjustment;
                this_.setOverridePropertyNumber('horizontalAdjustment', horizontalAdjustment);
                this_.setOverridePropertyNumber('verticalAdjustment', verticalAdjustment);
                object.setCoords();
                this_.canvas.calcOffset();
                this_.refreshObject(object);
                console.log('Object Moved -- top left scaleX scaleY topUnadjusted leftUnadjusted horizontalAdjustment verticalAdjustment : ' + top + " " + left + " " + scaleX + " " + scaleY + " " + topUnadjusted + " " + leftUnadjusted + " " + horizontalAdjustment + " " + verticalAdjustment );
                object.setCoords();
                this_.projectSaver.saveProjectAndCanvas(this, this_.project, this_.canvas);
              }
            }
          });
          this_.canvas.on('object:scaled', options => {
            if (this_.projectSaver && this_.canvas && this_.project.cover) {
              const object = this_.canvas.getActiveObject();
              if ( object && this_.getType() === 'image') {
                object.setCoords();
                const top = object.top;
                const left = object.left;
                const width = object.width;
                const height = object.height;
                let targetScale = this_.getOverridePropertyNumber('targetScale', undefined);
                if ( !targetScale ) {
                  targetScale = 1;
                }
                const scaleAdjustment = options.target.scaleX / (this_.project.cover.scale * targetScale ) ;
                this_.setOverridePropertyNumber('scaleAdjustment', scaleAdjustment);
                this_.canvas.calcOffset();
                object.setCoords();
                this_.refreshObject(object);
                this_.canvas.renderAll();
                console.log('Object Scaled -- top left scaleAdjustment   ' + top + " " + left + " " + scaleAdjustment);
                object.setCoords();
                this_.projectSaver.saveProjectAndCanvas(this, this_.project, this_.canvas);
              }
            }
          });

          // this_.canvas.on('object:removed', options => {
          //   if (this_.projectSaver && this_.canvas && this_.project.cover) {
          //     this_.projectSaver.saveProjectAndCanvas(this_.project, this_.canvas);
          //   }
          // });

          // this_.canvas.on('selection:updated', options => {
          //   if (this_.canvas) {
          //     this_.canvas.getActiveObject();
          //     if ( this_.currentlyActiveObject && this_.currentlyActiveObject === this_.canvas.getActiveObject() ) {
          //       this_.canvas.discardActiveObject();
          //     }
          //     this_.currentlyActiveObject = this_.canvas.getActiveObject();
          //     this_.canvas.renderAll();
          //   }
          // });

          // this_.canvas.on('mouse:up', options => {
          //   if (this_.canvas) {
          //     if ( this_.currentlyActiveObject && this_.currentlyActiveObject === this_.canvas.getActiveObject() && this_.getType() !== 'text' ) {
          //       // this_.canvas.discardActiveObject();
          //     }
          //     this_.currentlyActiveObject = this_.canvas.getActiveObject();
          //     this_.canvas.renderAll();
          //   }
          // });
          // this_.canvas.on('object:selected', options => {
          //   if (this_.canvas) {
          //     this_.canvas.renderAll();
          //   }
          // });
          // this_.canvas.on('group:selected', options => {
          //   if (this_.canvas) {
          //     this_.canvas.renderAll();
          //   }
          // });
          // this_.canvas.on('path:created', options => {
          //   if (this_.canvas) {
          //     this_.canvas.renderAll();
          //   }
          // });
          // this_.canvas.on('selection:cleared', options => {
          //   if (this_.canvas) {
          //     this_.canvas.renderAll();
          //   }
          // });
          resolve("success");
        });
      } else {
        return reject('Error -- could not apply cover theme because the coverTheme, canvas or the project does not exist.');
      }
    });
  }

  applyCoverTheme (coverTheme: CoverTheme, clearUserSettings: boolean) {
    console.log("Applying cover theme " + coverTheme.name + " " + coverTheme.id);

    let pages = this.MIN_PAGES_FOR_SPINE_THICKNESS;
    if ( this.spineSizeForDesigner ) {
      pages = 200;
    }
    if ( this.project && this.project.pages ) {
      if (this.project.pages >  this.MIN_PAGES_FOR_SPINE_THICKNESS ) {
        pages = this.project.pages;
      }
    }
    const prevSpineWidth = Number( this.project.spineWidth.substring(0, this.project.spineWidth.length - 2) );
    const newSpineWidth = pages / 2 * this.SHEET_THICKNESS + this.COVER_THICKNESS;
    this.project.spineWidth = newSpineWidth + 'in';
    if ( this.projectSaver && Math.abs(newSpineWidth - prevSpineWidth ) > 0.04 && this.canvas ) {
      this.projectSaver.saveProjectAndCanvas(this, this.project, this.canvas);
    }

    if ( this.canvas ) {
      this.setCoverEditorDisplayWidth();
      this.removeCoverGuideLines();
      this.applyToCanvas(coverTheme, this.project.cover.fontSettings, this.project.cover.colorPalette, clearUserSettings);
      if ( this.coverGridLines ) {
        this.addCoverGuideLines();
      }
      this.setCoverEditorDisplayWidth();
    }
    this.canvas.calcOffset();
    this.canvas.renderAll();
    this.canvas.calcOffset();
  }

  selectObjectBasedOnRole(role: string) {
    const object = this.getObjectBasedOnRole(role);
    if ( object ) {
      this.canvas.setActiveObject(object);
    }
    this.canvas.forEachObject(function (obj) {
      obj.setCoords();
    });
    this.canvas.calcOffset();
    this.canvas.renderAll();
    this.canvas.calcOffset();
  }


  refreshObjectBasedOnRole(role: string) {
    const themeItem = this.project.cover.coverTheme.getCoverThemeItemSetting(role);
    const object = this.getObjectBasedOnRole(role);
    if ( this.canvas && themeItem ) {
      this.applyToObject(this.project.cover.coverTheme, this.project.cover.fontSettings, this.project.cover.colorPalette, themeItem, object);
      object.setCoords();
      this.canvas.calcOffset();
      this.canvas.renderAll();
    }
  }
  refreshObject(object: any) {
    const role = object['role'];
    const themeItem = this.project.cover.coverTheme.getCoverThemeItemSetting(role);
    if ( this.canvas && themeItem ) {
      this.applyToObject(this.project.cover.coverTheme, this.project.cover.fontSettings, this.project.cover.colorPalette, themeItem, object);
      this.canvas.calcOffset();
      this.canvas.renderAll();
    }
  }

  applyToCanvas(coverTheme: CoverTheme, fontSettings: FontSettings, colorPalette: ColorPalette, clearUserSettings: boolean) {
    if ( this.project.cover && clearUserSettings) {
      // Clear all previous override values except for the text
      this.project.cover.clearAllButTextValues();

      // Set images to the first imageOption for each image themeItem
      for (const themeItem of coverTheme.objects) {
        if ( !themeItem.isHidden() && themeItem.getType() === 'image' ) {
          if ( themeItem.imageOptions && themeItem.imageOptions.length > 0 && themeItem.imageOptions[0].imageKey ) {
            const role = themeItem.getRole();
            this.project.cover.addImage(themeItem.imageOptions[0].imageKey, role);
            this.project.cover.setImagePropertyNumber(role, 'horizontalAdjustment', themeItem.imageOptions[0].horizontalAdjustment);
            this.project.cover.setImagePropertyNumber(role, 'vertocalAdjustment', themeItem.imageOptions[0].verticalAdjustment);
            this.project.cover.setImagePropertyNumber(role, 'scaleAdjustment', themeItem.imageOptions[0].scaleAdjustment);
          }
        }
      }
    }
    this.canvas.clear();
    for (const themeItem of coverTheme.objects) {
      const object = this.getObjectBasedOnRole(themeItem.getRole());
      this.applyToObject(coverTheme, fontSettings, colorPalette, themeItem, object);
    }
    this.setCoverEditorDisplayWidth();
    this.canvas.calcOffset();
    this.canvas.renderAll();
  }

  applyToObject(coverTheme: CoverTheme, fontSettings: FontSettings, colorPalette, themeItem: CoverThemeItemSetting, object: any) {
    if ( themeItem.getRole() === 'whole-hidden-image') {
      return;
    }
    const cover: Cover = this.project.cover;

    if ( !this.project.cover.scale ) {
      this.project.cover.scale = 1.0;
    }

    const canvasObjectProperties = new CanvasObjectProperties();
    canvasObjectProperties.objectCaching = false;
    canvasObjectProperties.hasControls = false;
    canvasObjectProperties.preserveObjectStacking = true;
    canvasObjectProperties.lockMovementX = true;
    canvasObjectProperties.lockMovementY = true;
    // canvasObjectProperties.lockScalingX = true;
    // canvasObjectProperties.lockScalingY = true;
    // canvasObjectProperties.visible = true;
    canvasObjectProperties.originX = 'left';
    canvasObjectProperties.originY = 'top';
    canvasObjectProperties.selectable = true;
    canvasObjectProperties.positionFit = 'inside';
    canvasObjectProperties.scaleAdjustment = 1;
    canvasObjectProperties.horizontalAdjustment = 0;
    canvasObjectProperties.verticalAdjustment = 0;
    canvasObjectProperties.movement = 'none'; // vertical, horizontal, all, none
    canvasObjectProperties.positionFit = '';
    canvasObjectProperties.orderId = 0;
    canvasObjectProperties.timestamp = Date.now();
    canvasObjectProperties.scaleX = this.project.cover.scale;
    canvasObjectProperties.scaleY = this.project.cover.scale;


    let areaLeft = 0;
    let areaTop = 0;
    let areaRight = 0;
    let areaBottom = 0;
    let areaWidth = 0;
    let areaHeight = 0;

    const spineWidth = Number( this.project.spineWidth.substring(0, this.project.spineWidth.length - 2) );
    const scaledPPI = Number( this.screenPPI * this.project.cover.scale );
    const widthInInches = Number( this.project.width.substring(0, this.project.width.length - 2) );
    const heightInInches = Number( this.project.height.substring(0, this.project.height.length - 2) );

    const coverWidth = ( widthInInches * 2 + spineWidth + 1) * scaledPPI;
    const coverHeight = ( heightInInches * 1 + 1) * scaledPPI;
    const scaledHalfInch = 0.5 * scaledPPI;
    const scaledWidth = widthInInches * scaledPPI;
    const scaledHeight = heightInInches * scaledPPI;
    const scaledSpineWidth = spineWidth * scaledPPI;

    const backLeft = scaledHalfInch;
    const backRight = backLeft + scaledWidth;
    const backTop = scaledHalfInch;
    const backBottom = backTop + scaledHeight;

    const spineLeft = backRight;
    const spineRight = spineLeft + scaledSpineWidth;
    const spineTop = scaledHalfInch;
    const spineBottom = spineTop + scaledHeight;

    const frontLeft = spineRight;
    const frontRight = frontLeft + scaledWidth;
    const frontTop = scaledHalfInch;
    const frontBottom = frontTop + scaledHeight;

    const wholeLeft = backLeft;
    const wholeRight = frontRight;
    const wholeTop = backTop;
    const wholeBottom = frontBottom;

    if (themeItem.isActive() ) {
      const role = themeItem.getRole();
      canvasObjectProperties.orderId = themeItem.orderId;
      canvasObjectProperties.role = role;
      // if (themeItem.hasFont()) {
      if ( themeItem.getType() === 'textbox') {
        let fontFamilyPosition = cover.getImagePropertyString(role, 'fontFamily', undefined);
        if ( !fontFamilyPosition || ( fontFamilyPosition && fontFamilyPosition.length === 0 ) ) {
          fontFamilyPosition = themeItem.getFontFamily();
        }
        canvasObjectProperties.fontFamily = this.project.cover.fontSettings.getFontFromKey(fontFamilyPosition, '');
        canvasObjectProperties.textAlign = cover.getImagePropertyString(role, 'textAlign', themeItem.getTextAlign());
        canvasObjectProperties.fontWeight = cover.getImagePropertyString(role, 'fontWeight', themeItem.getFontWeight());
        canvasObjectProperties.fontStyle = cover.getImagePropertyString(role, 'fontStyle', themeItem.getFontStyle());
        canvasObjectProperties.charSpacing = cover.getImagePropertyNumber(role, 'charSpacing', themeItem.getCharSpacing());
        canvasObjectProperties.lineHeight = cover.getImagePropertyNumber(role, 'lineHeight', themeItem.getLineHeight());
        canvasObjectProperties.fontSize = cover.getImagePropertyNumber(role, 'fontSize', themeItem.getFontSize());

        const textValue = cover.getImagePropertyString(role, 'text', undefined);
        const notext = cover.getImagePropertyBoolean(role, 'notext', false);
        if (textValue) {
          canvasObjectProperties.text = textValue;
          cover.setImagePropertyBoolean(role, 'notext', false);
        } else {
          if (notext) {
            canvasObjectProperties.text = ' ';
            cover.setImagePropertyBoolean(role, 'notext', true);
          } else {
            if (this.projectSaver) {
              canvasObjectProperties.text = themeItem.getDefaultText();
            }
            canvasObjectProperties.notext = false;
          }
        }

        const textStyles = cover.getImagePropertyObject(role, 'textStyles', undefined);
        if (textStyles) {
          canvasObjectProperties['styles'] = textStyles;
        } else {
          canvasObjectProperties['styles'] = {};
          // const emptyTextStyles = {};
          // cover.setImagePropertyObject(role, 'textStyles', emptyTextStyles);
          // canvasObjectProperties.styles = emptyTextStyles;
        }
      }

      canvasObjectProperties.scaleAdjustment = this.project.cover.getImagePropertyNumber(role, 'scaleAdjustment', 1);
      canvasObjectProperties.horizontalAdjustment = this.project.cover.getImagePropertyNumber(role, 'horizontalAdjustment', 0);
      canvasObjectProperties.verticalAdjustment = this.project.cover.getImagePropertyNumber(role, 'verticalAdjustment', 0);

      if ( themeItem.getType() === 'image') {
        if (this.project.cover.imagesByRole[role] && this.project.cover.imagesByRole[role].key) {
          canvasObjectProperties.imageKey = this.project.cover.imagesByRole[role].key;
        } else {
          canvasObjectProperties.imageKey = '';
          if ( themeItem.imageOptions && themeItem.imageOptions.length > 0 ) {
            if ( themeItem.imageOptions[0].imageKey ) {
              canvasObjectProperties.imageKey = themeItem.imageOptions[0].imageKey;
              // Override the set values for scale, horizontal and vertical adjustment IF we are using the themeItem's imageOption
              canvasObjectProperties.scaleAdjustment = themeItem.imageOptions[0].scaleAdjustment;
              canvasObjectProperties.horizontalAdjustment = themeItem.imageOptions[0].horizontalAdjustment;
              canvasObjectProperties.verticalAdjustment = themeItem.imageOptions[0].verticalAdjustment;
            }
          }
        }
      }

      canvasObjectProperties.opacity = this.project.cover.getImagePropertyNumber(role, 'opacity', Number(themeItem.getOpacity()));
      if ( canvasObjectProperties.opacity > 1) {
        canvasObjectProperties.opacity = 1;
      }
      if ( canvasObjectProperties.opacity < 0) {
        canvasObjectProperties.opacity = 0;
      }
      canvasObjectProperties.movement = this.project.cover.getImagePropertyString(role, 'movement', themeItem.getMovement());
      canvasObjectProperties.positionFit = this.project.cover.getImagePropertyString(role, 'positionFit', themeItem.getPositionFit());

      const coverArea = themeItem.getCoverArea();
      switch (coverArea) {
        case "front": {
          areaLeft = frontLeft;
          areaTop = frontTop;
          areaRight = frontRight;
          areaBottom = frontBottom;
          break;
        }
        case "back": {
          areaLeft = backLeft;
          areaTop = backTop;
          areaRight = backRight;
          areaBottom = backBottom;
          break;
        }
        case "spine": {
          areaLeft = spineLeft;
          areaTop = spineTop;
          areaRight = spineRight;
          areaBottom = spineBottom;
          break;
        }
        case "whole": {
          canvasObjectProperties.selectable = this.backgroundObjectsSelectable;
          areaLeft = wholeLeft;
          areaTop = wholeTop;
          areaRight = wholeRight;
          areaBottom = wholeBottom;
          break;
        }
      }

      areaWidth = areaRight - areaLeft;
      areaHeight = areaBottom - areaTop;

      canvasObjectProperties.angle = themeItem.getRotation();
      if (themeItem.getColor() && themeItem.getColor().length === 0) {
        canvasObjectProperties.background = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'color', themeItem.getColor()), 'primary.normal');
      } else {
        canvasObjectProperties.background = 'rgba(1,1,1, 0)';
      }

      canvasObjectProperties.originX = themeItem.getOriginX();
      canvasObjectProperties.originY = themeItem.getOriginY();

      const controls = new Controls();
      controls.middleTopControl = false;
      controls.middleBottomControl = false;
      controls.middleLeftControl = false;
      controls.middleRightControl = false;
      controls.bottomLeftControl = true;
      controls.bottomRightControl = true;
      controls.topLeftControl = true;
      controls.topRightControl = true;
      controls.rotationControl = false;

      switch (canvasObjectProperties.movement) {
        case 'horizontal': {
          canvasObjectProperties.lockMovementX = false;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = true;
          break;
        }
        case 'vertical': {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = false;
          canvasObjectProperties.hasControls = true;
          break;
        }
        case 'both': {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = true;
          break;
        }
        case 'none': {
          canvasObjectProperties.lockMovementX = false;
          canvasObjectProperties.lockMovementY = false;
          canvasObjectProperties.hasControls = false;
          break;
        }
        default: {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = false;
          break;
        }
      }


      const positionAndSize = themeItem.getPosition(areaTop, areaLeft, areaBottom, areaRight, this.project.cover.scale);
      canvasObjectProperties.left = positionAndSize.left;
      canvasObjectProperties.right = positionAndSize.right;
      canvasObjectProperties.top = positionAndSize.top;
      canvasObjectProperties.bottom = positionAndSize.bottom;
      canvasObjectProperties.height = positionAndSize.height / this.project.cover.scale; // Set the height and width to the unscaled values and let scaleX and scaleY do the work
      canvasObjectProperties.width = positionAndSize.width / this.project.cover.scale;
      if (canvasObjectProperties.angle === 90 || canvasObjectProperties.angle === 270) {
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      } else {
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      }

      // Scale Adjustment
      canvasObjectProperties.scaleAdjustment = this.project.cover.getImagePropertyNumber(role, 'scaleAdjustment', 1);

      const widthScaleChange = ( canvasObjectProperties.scaleAdjustment - 1 ) * canvasObjectProperties.width;
      switch ( canvasObjectProperties.originX ) {
        case 'left': {
          canvasObjectProperties.right += widthScaleChange;
          break;
        }
        case 'right': {
          canvasObjectProperties.left -= widthScaleChange;
          break;
        }
        case 'center': {
          canvasObjectProperties.left -= widthScaleChange / 2;
          canvasObjectProperties.right += widthScaleChange / 2;
          break;
        }
        default: {
          canvasObjectProperties.left -= widthScaleChange / 2;
          canvasObjectProperties.right += widthScaleChange / 2;
          break;
        }
      }

      const heightScaleChange = ( canvasObjectProperties.scaleAdjustment - 1 ) * canvasObjectProperties.height;
      switch ( canvasObjectProperties.originY ) {
        case 'top': {
          canvasObjectProperties.bottom += heightScaleChange;
          break;
        }
        case 'bottom': {
          canvasObjectProperties.top -= heightScaleChange;
          break;
        }
        case 'center': {
          canvasObjectProperties.top -= heightScaleChange / 2;
          canvasObjectProperties.bottom += heightScaleChange / 2;
          break;
        }
        default: {
          canvasObjectProperties.top -= heightScaleChange / 2;
          canvasObjectProperties.bottom += heightScaleChange / 2;
          break;
        }
      }

      if (canvasObjectProperties.angle === 90 || canvasObjectProperties.angle === 270) {
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      } else {
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      }


      // Position Adjustment
      canvasObjectProperties.top += canvasObjectProperties.verticalAdjustment * ( areaBottom - areaTop );
      canvasObjectProperties.bottom += canvasObjectProperties.verticalAdjustment * ( areaBottom - areaTop );
      canvasObjectProperties.left += canvasObjectProperties.horizontalAdjustment * ( areaRight - areaLeft );
      canvasObjectProperties.right += canvasObjectProperties.horizontalAdjustment * ( areaRight - areaLeft );

      if (canvasObjectProperties.angle === 90 || canvasObjectProperties.angle === 270) {
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      } else {
        canvasObjectProperties.width = Math.abs(canvasObjectProperties.right - canvasObjectProperties.left) / this.project.cover.scale;
        canvasObjectProperties.height = Math.abs(canvasObjectProperties.bottom - canvasObjectProperties.top) / this.project.cover.scale;
      }

      // Show/Hide is accomplished by making the object NOT selectable and an opacity of zero
      if ( cover.getImagePropertyBoolean(role, 'hidden', themeItem.isHidden()) ) {
        canvasObjectProperties.opacity = 0;
        canvasObjectProperties.selectable = false;
        // cover.setImagePropertyObject(role, 'hidden', true);
      }

      switch (themeItem.getType()) {
        case "textbox": {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = false;
          if (!canvasObjectProperties.text) {
            canvasObjectProperties.text = ' ';
          }
          // if (!themeItem.isActive()) {
          //   canvasObjectProperties.visible = false; // Allow textboxes to be included even if the themeItem is not active so that the text values will be carried from other themes that do use the themeItem
          // }
          canvasObjectProperties.background = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'fontColor', themeItem.getFontColor()), 'quinary.normal');
          canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'fontColor', themeItem.getFontColor()), 'quinary.normal');
          // canvasObjectProperties.editable = true;
          if (!(coverArea === "spine") || (coverArea === "spine" && spineWidth > 0.2)) {
            if (object) {
              for (const prop of Object.keys(canvasObjectProperties)) {
                if (canvasObjectProperties[prop] || canvasObjectProperties[prop] === 0 || canvasObjectProperties[prop] === false) {
                  object.set(prop, canvasObjectProperties[prop]);
                }
              }
              // object.clipTo = function (ctx) {
              //   ctx.rect(areaLeft, areaTop, areaWidth, areaHeight);
              // };
            } else {
              const textbox = new fabric.Textbox(canvasObjectProperties.text, canvasObjectProperties);
              // textbox.clipTo = function (ctx) {
              //   ctx.rect(areaLeft, areaTop, areaWidth, areaHeight);
              // };
              // textbox.set('stroke', '#ff0088');
              // textbox.set('strokeWidth', '1');
              this.canvas.add(textbox);
            }
          }
          break;
        }
        case "rectangle": {
          // canvasObjectProperties.selectable = false;
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = false;
          // canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(themeItem.getColor(), 'primary.normal');
          canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'color', themeItem.getColor()), 'primary.normal');
          if (object) {
            for (const prop of Object.keys(canvasObjectProperties)) {
              object.set(prop, canvasObjectProperties[prop]);
            }
            // object.clipTo = function (ctx) {
            //   ctx.rect(-areaWidth / 2, -areaHeight / 2, areaWidth, areaHeight);
            // };
          } else {
            const rect = new fabric.Rect(canvasObjectProperties);
            // rect.clipTo = function (ctx) {
            //   ctx.rect(-areaWidth / 2, -areaHeight / 2, areaWidth, areaHeight);
            // };
            this.canvas.add(rect);
          }
          break;
        }
        case "circle": {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = false;
          canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'color', themeItem.getColor()), 'quinary.normal');
          // canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(themeItem.getColor(), 'primary.normal');
          canvasObjectProperties.radius = (positionAndSize.right - positionAndSize.left) / 2;
          canvasObjectProperties.scaleX = 1.0;
          canvasObjectProperties.scaleY = (positionAndSize.top - positionAndSize.bottom) / (positionAndSize.right - positionAndSize.left);

          if (object) {
            for (const prop of Object.keys(canvasObjectProperties)) {
              object.set(prop, canvasObjectProperties[prop]);
            }
          } else {
            const circle = new fabric.Circle(canvasObjectProperties);
            // circle.clipTo = function (ctx) {
            //   ctx.rect(areaLeft, areaTop, areaWidth, areaHeight);
            // };
            this.canvas.add(circle);
          }
          break;
        }
        case "line": {
          canvasObjectProperties.lockMovementX = true;
          canvasObjectProperties.lockMovementY = true;
          canvasObjectProperties.hasControls = false;
          canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'color', themeItem.getColor()), 'quinary.normal');
          // this.canvas.add(new fabric.Line(canvasObjectProperties));
          if (object) {
            for (const prop of Object.keys(canvasObjectProperties)) {
              object.set(prop, canvasObjectProperties[prop]);
            }
          } else {
            const line = new fabric.Line([0, 0, 200, 200], canvasObjectProperties);
            // line.clipTo = function (ctx) {
            //   ctx.rect(areaLeft, areaTop, areaWidth, areaHeight);
            // };
            this.canvas.add(line);
          }
          break;
        }
        case "image": {
          this.project.cover.addImage(canvasObjectProperties.imageKey, role);
          console.log("Image:" + role + " - " + canvasObjectProperties.imageKey);
          let imgElement: any = document.getElementById(canvasObjectProperties.imageKey);

          if ( !canvasObjectProperties.imageKey || canvasObjectProperties.imageKey.length === 0 ) {
            imgElement = document.getElementById('imagePlaceholder');
          }
          if (imgElement) {
            if (imgElement.complete || !this.projectSaver) {
              this.applyImageToCanvas(role, canvasObjectProperties, imgElement, object, coverWidth, coverHeight, controls, cover, areaLeft, areaTop, areaWidth, areaHeight);
            } else {
              imgElement.addEventListener('load', _ => {
                console.log(`Success loading image ${canvasObjectProperties.imageKey}`);
                this.applyImageToCanvas(role, canvasObjectProperties, imgElement, object, coverWidth, coverHeight, controls, cover, areaLeft, areaTop, areaWidth, areaHeight);
              });
              imgElement.addEventListener('error', _ => {
                console.log(`Error loading image ${canvasObjectProperties.imageKey}`);
              });
            }
          } else {
            console.log("Image that should have been loaded was not found in CanvasManager");
            // We could wait around for the image to load and then add it in
          }
          // ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // canvasObjectProperties.fill = 'rgba(20,20,20,0.4)';
          // canvasObjectProperties.lockMovementX = true;
          // canvasObjectProperties.lockMovementY = true;
          // canvasObjectProperties.hasControls = false;
          // // canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(themeItem.getColor(), 'primary.normal');
          // canvasObjectProperties.fill = this.project.cover.colorPalette.getColorFromKey(cover.getImagePropertyString(role, 'color', themeItem.getColor()), 'primary.normal');
          // if (object) {
          //   for (const prop of Object.keys(canvasObjectProperties)) {
          //     object.set(prop, canvasObjectProperties[prop]);
          //   }
          // } else {
          //   this.canvas.add(new fabric.Rect(canvasObjectProperties));
          // }
          // END ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // END ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // END ADD A RECTANGLE FOR DEBUGGING PURPOSES
          // END ADD A RECTANGLE FOR DEBUGGING PURPOSES

          break;
        }
        default: {
          console.error("Default case when adding an item to a cover");
          break;
        }
      }
    }
  }


  applyImageToCanvas(role: string, canvasObjectProperties: CanvasObjectProperties, imgElement: HTMLImageElement, object: any, coverWidth: number, coverHeight: number, controls: Controls, cover: Cover, areaLeft: number, areaTop: number, areaWidth: number, areaHeight: number) {
    let isSelected = false;
    if (object === this.getSelected()) {
      isSelected = true;
    }
    // canvasObjectProperties.lockScalingX = false;
    // canvasObjectProperties.lockScalingY = false;

    canvasObjectProperties.hasControls = true;

    let replaceImageObject: boolean = true;
    // If the image object already exsists and points to the same object then don't replace it
    if ( object && object.imageKey && object.imageKey === imgElement.id ) {
      replaceImageObject = false;
    }

    const height = canvasObjectProperties.height;
    const width = canvasObjectProperties.width;
    let targetScale = 1.0;
    const targetHeightToWidthRatio = canvasObjectProperties.height / canvasObjectProperties.width;
    let naturalHeight = imgElement['naturalHeight'];
    let naturalWidth = imgElement['naturalWidth'];
    if ( !naturalHeight ) {
      naturalHeight = imgElement.offsetHeight;
    }
    if ( !naturalWidth ) {
      naturalWidth = imgElement.offsetWidth;
    }
    // if ( this.projectSaver ) {
    //   // cover.setImagePropertyObject(role, 'naturalHeight', naturalHeight);
    //   // cover.setImagePropertyObject(role, 'naturalWidth', naturalWidth);
    // } else {
    //   // naturalHeight = cover.getImagePropertyNumber(role, 'natualHeight', imgElement.offsetHeight);
    //   // naturalWidth = cover.getImagePropertyNumber(role, 'naturalWidth', imgElement.offsetWidth);
    //   naturalHeight = imgElement.offsetHeight;
    //   naturalWidth = imgElement.offsetWidth;
    // }

    let topImageDifferentRatioAdjustment = 0;
    let leftImageDifferentRatioAdjustment = 0;
    let widthImageDifferentRatioAdjustment = 0;
    let heightImageDifferentRatioAdjustment = 0;

    const sourceHeightToWidthRatio = naturalHeight / naturalWidth;
    switch ( canvasObjectProperties.positionFit ) {
      case 'inside': {
        if ( targetHeightToWidthRatio <= sourceHeightToWidthRatio ) {
          targetScale = canvasObjectProperties.height / naturalHeight;
          widthImageDifferentRatioAdjustment = ( ( naturalWidth * canvasObjectProperties.height ) / naturalHeight ) - canvasObjectProperties.width;
          leftImageDifferentRatioAdjustment = widthImageDifferentRatioAdjustment / 2;
          // this.setOverridePropertyNumber('leftImageDifferentRatioAdjustment', leftImageDifferentRatioAdjustment / coverWidth);
        } else {
          targetScale = canvasObjectProperties.width / naturalWidth;
          heightImageDifferentRatioAdjustment = ( ( naturalHeight * canvasObjectProperties.width ) / naturalWidth ) - canvasObjectProperties.height;
          topImageDifferentRatioAdjustment = heightImageDifferentRatioAdjustment / 2;
          // this.setOverridePropertyNumber('topImageDifferentRatioAdjustment', topImageDifferentRatioAdjustment / coverHeight);
        }
        break;
      }

      case 'outside': {
        if ( targetHeightToWidthRatio > sourceHeightToWidthRatio ) {
          targetScale = canvasObjectProperties.height / naturalHeight;
          widthImageDifferentRatioAdjustment = ( ( naturalWidth * canvasObjectProperties.height ) / naturalHeight ) - canvasObjectProperties.width;
          leftImageDifferentRatioAdjustment = widthImageDifferentRatioAdjustment / 2;
          // this.setOverridePropertyNumber('leftImageDifferentRatioAdjustment', leftImageDifferentRatioAdjustment / coverWidth);
        } else {
          targetScale = canvasObjectProperties.width / naturalWidth;
          heightImageDifferentRatioAdjustment = ( ( naturalHeight * canvasObjectProperties.width ) / naturalWidth ) - canvasObjectProperties.height;
          topImageDifferentRatioAdjustment = heightImageDifferentRatioAdjustment / 2;
          // this.setOverridePropertyNumber('topImageDifferentRatioAdjustment', topImageDifferentRatioAdjustment / coverHeight);
        }
        // if ( targetHeightToWidthRatio >= sourceHeightToWidthRatio ) {
        //   targetScale = canvasObjectProperties.height / naturalHeight;
        // } else {
        //   targetScale = canvasObjectProperties.width / naturalWidth;
        // }
        break;
      }
      case 'matchHeight': {
        break;
      }
      case 'matchWidth': {
        break;
      }
      case 'widthOutside': {
        break;
      }
      case 'heightOutside': {
        break;
      }
      default: {
      }
    }
    // if ( this.projectSaver ) {
    //  this.setOverridePropertyNumber('targetScale', targetScale);
    // } else {
    //   targetScale = this.getOverridePropertyNumber( 'targetScale', targetScale );
    // }


    const imageProperties = {};
    imageProperties['role'] = role;
    imageProperties['orderId'] = canvasObjectProperties.orderId;
    // imageProperties['scaleX'] = targetScale * canvasObjectProperties.scaleAdjustment;
    // imageProperties['scaleY'] = targetScale * canvasObjectProperties.scaleAdjustment;
    // imageProperties['scaleX'] = targetScale * canvasObjectProperties.scaleAdjustment * this.project.cover.scale;
    // imageProperties['scaleY'] = targetScale * canvasObjectProperties.scaleAdjustment * this.project.cover.scale;
    // imageProperties['topUnadjusted'] = canvasObjectProperties.top / this.project.cover.scale;
    // imageProperties['leftUnadjusted'] = canvasObjectProperties.left / this.project.cover.scale;
    // imageProperties['top'] = canvasObjectProperties.top - topImageDifferentRatioAdjustment + canvasObjectProperties.verticalAdjustment * coverHeight;
    // imageProperties['left'] = canvasObjectProperties.left - leftImageDifferentRatioAdjustment + canvasObjectProperties.horizontalAdjustment * coverWidth;
    // imageProperties['width'] = (canvasObjectProperties.width + widthImageDifferentRatioAdjustment) / targetScale; // Change the width to include scaling
    // imageProperties['height'] = (canvasObjectProperties.height + heightImageDifferentRatioAdjustment) / targetScale; // Change the height to include scaling

    imageProperties['top'] = canvasObjectProperties.top; // - topImageDifferentRatioAdjustment + canvasObjectProperties.verticalAdjustment * coverHeight;
    imageProperties['left'] = canvasObjectProperties.left; // - leftImageDifferentRatioAdjustment + canvasObjectProperties.horizontalAdjustment * coverWidth;
    // imageProperties['width'] = (canvasObjectProperties.width); // + widthImageDifferentRatioAdjustment) / targetScale; // Change the width to include scaling
    // imageProperties['height'] = (canvasObjectProperties.height); // + heightImageDifferentRatioAdjustment) / targetScale; // Change the height to include scaling

    // canvasObjectProperties.originX = 'left';
    // canvasObjectProperties.originY = 'top';
    imageProperties['originX'] = canvasObjectProperties.originX;
    imageProperties['originY'] = canvasObjectProperties.originY;
    // if ( canvasObjectProperties.originX === 'right') {
    //   imageProperties['originX'] = 'center';
    // }
    // if ( canvasObjectProperties.originY === 'bottom') {
    //   imageProperties['originY'] = 'center';
    // }

    imageProperties['opacity'] = canvasObjectProperties.opacity;
    imageProperties['hasControls'] = canvasObjectProperties.hasControls;
    imageProperties['selectable'] = canvasObjectProperties.selectable;
    imageProperties['lockMovementX'] = canvasObjectProperties.lockMovementX;
    imageProperties['lockMovementY'] = canvasObjectProperties.lockMovementY;
    // imageProperties['lockScalingX'] = canvasObjectProperties.lockScalingX;
    // imageProperties['lockScalingY'] = canvasObjectProperties.lockScalingY;
    // imageProperties['centeredScaling'] = true;
    imageProperties['imageKey'] = canvasObjectProperties.imageKey;
    imageProperties['timestamp'] = canvasObjectProperties.timestamp;
    imageProperties['preserveObjectStacking'] = canvasObjectProperties.preserveObjectStacking;
    imageProperties['objectCaching'] = canvasObjectProperties.objectCaching;

    let image = object;
    // clipTo: function (ctx) {
    //   ctx.arc(0, 0, radius, 0, Math.PI * 2, true);
    // }
    // Replace the image object because the HTML image element behind it has changed OR it is being newly added
    if ( replaceImageObject ) {
      if (object) {
        this.canvas.remove(object);
        this.canvas.calcOffset();
        this.canvas.renderAll();
      }
      image = new fabric.Image(imgElement, imageProperties);
      // image = new fabric.Image(imgElement, {});
      let i = 0;
      for (; i < this.canvas._objects.length && this.canvas._objects[i].orderId && this.canvas._objects[i].orderId < image.orderId; i++) {
      }
      this.canvas._objects.splice(i, 0, image);
    } else { // If the same image being used, simply change the properties
      for ( const prop of Object.keys(imageProperties) ) {
        image.set(prop,  imageProperties[prop]);
      }
      // if ( canvasObjectProperties.originX === 'right') {
      //   image.set('originX', 'center');
      // }
      // if ( canvasObjectProperties.originY === 'bottom') {
      //   image.set('originY', 'center');
      // }
    }
    const originalSize = image.getOriginalSize();
    console.log('Image original size: ' + originalSize.width + ' x ' + originalSize.height  );
    console.log('Scaled width: ' + image.getScaledWidth() );
    console.log('Scaled height: ' + image.getScaledHeight() );
    console.log('Object Scaling: ' + image.getObjectScaling().scaleX + ' x ' + image.getObjectScaling().scaleY);
    console.log('Target Placement: top[' + canvasObjectProperties.top + '] left[' +  canvasObjectProperties.left + '] width[' +  canvasObjectProperties.width + '] height[' +  canvasObjectProperties.height + ']');
    console.log('targetScale:' + targetScale);
    image.setCoords();
    this.canvas.renderAll();
    this.canvas.calcOffset();



    const rectProperties = {};
    rectProperties['top'] = canvasObjectProperties.top;
    rectProperties['left'] = canvasObjectProperties.left;
    rectProperties['width'] = canvasObjectProperties.width;
    rectProperties['height'] = canvasObjectProperties.height;
    rectProperties['originX'] = canvasObjectProperties.originX;
    rectProperties['originY'] = canvasObjectProperties.originY;
    const clipPath = new fabric.Rect(rectProperties);
    image.clipPath = clipPath;

    targetScale = targetScale * this.project.cover.scale;
    image.scale(targetScale);


    console.log('Image clipping area[left top width height]: ' + areaLeft + ' ' + areaTop + ' ' + areaWidth + ' ' + areaHeight );
    console.log('Image clipping area2[left top width height]: ' + -image.getScaledWidth() / 2 + ' ' +  -image.getScaledHeight() / 2 + ' ' + areaWidth + ' ' + areaHeight );
    console.log('Image clipping area3[left top width height]: ' + -image.getScaledWidth() + ' ' +  -image.getScaledHeight() + ' ' + areaWidth + ' ' + areaHeight );
    console.log('Image clipping area4[left top width height]: ' + -originalSize.width / 2 + ' ' +  -originalSize.height / 2 + ' ' + areaWidth + ' ' + areaHeight );

    let clipToHeight = canvasObjectProperties.height  / targetScale;
    let clipToWidth = canvasObjectProperties.width / targetScale;

    const extraWidth = originalSize.width - (canvasObjectProperties.width  / targetScale );
    const extraHeight = originalSize.height - (canvasObjectProperties.height  / targetScale);
    console.log('Image clipping area5[extraWidth extraHeight]: ' + extraWidth + ' ' + extraHeight );
    let clipToLeft = -originalSize.width / 2;
    switch ( canvasObjectProperties.originX ) {
      case 'left': {
        break;
      }
      case 'center': {
        if ( extraWidth < 0 ) {
          clipToWidth = ( canvasObjectProperties.width  / targetScale ) + ( extraWidth / 2 );
        } else if ( extraWidth > 0) {
          clipToLeft = ( -originalSize.width / 2 ) + ( extraWidth / 2 );
        }
        break;
      }
      case 'right': {
        if ( extraWidth < 0 ) {
          clipToLeft = originalSize.width * 2 + ( canvasObjectProperties.width  / targetScale );
          clipToWidth = ( canvasObjectProperties.width  / targetScale ) + ( extraWidth );
        } else if ( extraWidth > 0) {
          clipToWidth = ( canvasObjectProperties.width  / targetScale ) + ( extraWidth );
          clipToLeft = ( -originalSize.width / 2 ) - ( extraWidth );
        }
        break;
      }
    }

    let clipToTop = -originalSize.height / 2;
    switch ( canvasObjectProperties.originY ) {
      case 'top': {
        break;
      }
      case 'center': {
        if ( extraHeight < 0 ) {
          clipToHeight = ( canvasObjectProperties.height  / targetScale ) + ( extraHeight / 2 );
        } else if ( extraHeight > 0) {
          clipToTop = ( -originalSize.height / 2 ) + ( extraHeight / 2 );
        }
        break;
      }
      case 'bottom': {
        if ( extraHeight < 0 ) {
          clipToTop = (-originalSize.height / 2) + 100;
          clipToHeight = ( canvasObjectProperties.height  / targetScale ) + ( extraHeight );
        } else if ( extraHeight > 0) {
          clipToTop = ( -originalSize.height / 2 ) + ( extraHeight );
        }
        break;
      }
    }
    // image.clipTo = function (ctx) {
    //   ctx.rect( clipToLeft, clipToTop, clipToWidth, clipToHeight );
    // }

    // this.canvas.getContext().drawImage(imgElement, 0, 0, originalSize.width, originalSize.height, canvasObjectProperties.top, canvasObjectProperties.left, canvasObjectProperties.width, canvasObjectProperties.height);
    image.setCoords();
    this.canvas.renderAll();
    this.canvas.calcOffset();
    console.log('After scaling - Image original size: ' + originalSize.width + ' x ' + originalSize.height  );
    console.log('After scaling - Scaled width: ' + image.getScaledWidth() );
    console.log('After scaling - Scaled height: ' + image.getScaledHeight() );
    console.log('After scaling - Object Scaling: ' + image.getObjectScaling().scaleX + ' x ' + image.getObjectScaling().scaleY);
    // image.scaleToHeight(canvasObjectProperties.height, false);
    image.setCoords();
    this.canvas.renderAll();
    this.canvas.calcOffset();

    image.setControlsVisibility({
      mt: controls.middleTopControl, mb: controls.middleBottomControl, ml: controls.middleLeftControl, mr: controls.middleRightControl, bl: controls.bottomLeftControl, br: controls.bottomRightControl, tl: controls.topLeftControl, tr: controls.topRightControl, mtr: controls.rotationControl
    });


    if (isSelected) {
      this.canvas.setActiveObject(image);
    }
    image.setCoords();
    this.canvas.renderAll();
    this.canvas.calcOffset();
  }


  removeCoverGuideLines () {
    this.coverGridLines = false;
    const objects = this.canvas.getObjects();
    for (let i = objects.length - 1; i >= 0; i--) {
      const strokeWidth = objects[i].strokeWidth;
      if (strokeWidth - Math.floor(strokeWidth) === 0.91) {
        this.canvas.remove(objects[i]);
      }
    }
    this.canvas.renderAll();
    this.canvas.calcOffset();
  }

  resetAdjustments() {
    // this.project.cover.clearImages();
    this.applyCoverTheme(this.project.cover.coverTheme, true);
  }



  getObjectBasedOnRole(role: string) {
    if ( !this.canvas ) {
      return undefined;
    }
    for (const object of this.canvas.getObjects()) {
      if ( object.role === role) {
        return object;
      }
    }
    return undefined;
  }
  removeCanvasObjectById (objectId) {
    try {

      // const line = this.canvas.getActiveObject().get(objectId);
      const activeObject = this.canvas.getActiveObject();
      const line = activeObject.get(objectId);
      this.canvas.remove(line);
    } catch (err) {
      console.log(err);
    }

  }

  addCoverGuideLines () {
    this.coverGridLines = true;
    const scaledPPI = this.screenPPI * this.project.cover.scale;
    const widthInInches = Number(this.project.width.substring(0, this.project.width.length - 2));
    const heightInInches = Number(this.project.height.substring(0, this.project.height.length - 2));

    const coverWidth = ( widthInInches * 2 + Number(this.project.spineWidth.substring(0, this.project.spineWidth.length - 2)) + 1) * scaledPPI;
    const coverHeight = (heightInInches * 1 + 1) * scaledPPI;
    const scaledHalfInch = 0.5 * scaledPPI;

    // console.log("Adding Cover Guide Lines-- this.project.cover.scale coverWidth coverHeight this.scaledHalfInch this.scaledPPI [" + this.project.cover.scale + " " + coverWidth + " " + coverHeight + " " + this.scaledHalfInch + " " + this.scaledPPI + "]");
    const strokeWidth = 0.91;

    // Horizontal top
    this.canvas.add(new fabric.Line([0, 0, coverWidth, 0], {
      left: 0, top: scaledHalfInch, hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));

    // Horizontal bottom
    this.canvas.add(new fabric.Line([0, 0, coverWidth, 0], {
      left: 0, top: (coverHeight - scaledHalfInch), hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));

    // Vertical left
    this.canvas.add(new fabric.Line([0, 0, 0, coverHeight], {
      left: scaledHalfInch, top: 0, hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));

    // Vertical right
    this.canvas.add(new fabric.Line([0, 0, 0, coverHeight], {
      left: coverWidth - scaledHalfInch, top: 0, hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));

    // Vertical left spine
    const spineLeftX = (coverWidth - Number(this.project.spineWidth.substring(0, this.project.spineWidth.length - 2)) * scaledPPI) / 2;
    this.canvas.add(new fabric.Line([0, 0, 0, coverHeight], {
      left: spineLeftX, top: 0, hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));

    // Vertical right spine
    const spineRightX = spineLeftX + Number(this.project.spineWidth.substring(0, this.project.spineWidth.length - 2)) * scaledPPI;
    this.canvas.add(new fabric.Line([0, 0, 0, coverHeight], {
      left: spineRightX, top: 0, hasControls: false, preserveObjectStacking: true, strokeWidth: strokeWidth, stroke: 'red'
    }));
  }

  setCoverEditorDisplayWidth () {
    const scaledPPI = this.screenPPI * this.project.cover.scale;
    const widthInInches = Number(this.project.width.substring(0, this.project.width.length - 2));
    const heightInInches = Number(this.project.height.substring(0, this.project.height.length - 2));
    const coverWidth = (widthInInches * 2 + Number(this.project.spineWidth.substring(0, this.project.spineWidth.length - 2)) + 1) * scaledPPI;
    const coverHeight = (heightInInches * 1 + 1) * scaledPPI;
    // this.canvas.setHeight(coverHeight);
    // this.canvas.setWidth(coverWidth);
    this.canvas.setDimensions({width: coverWidth, height: coverHeight});
    // this.canvas.setDimensions({width: coverWidth, height: coverHeight}, {cssOnly: true});
    this.canvas.renderAll();
    this.canvas.calcOffset();
//    this.zoomIt(1, true);

    // this.canvas.renderAll();
    // this.canvas.calcOffset();
    // this.canvas.renderAll();
  }

  refresh() {
    if ( this.project.cover.coverTheme ) {
      this.applyCoverTheme(this.project.cover.coverTheme, false);
    }
  }

  toggleSpineSizeForDesigner() {
    if (this.spineSizeForDesigner) {
      this.spineSizeForDesigner = false;
      this.refresh();
    } else {
      this.spineSizeForDesigner = true;
      this.refresh();
    }
  }

  toggleBackgroundObjectsSelectable() {
    if (this.backgroundObjectsSelectable) {
      this.backgroundObjectsSelectable = false;
      this.refresh();
    } else {
      this.backgroundObjectsSelectable = true;
      this.refresh();
    }
  }
  toggleGridLines () {
    if (this.coverGridLines) {
      this.coverGridLines = false;
      this.removeCoverGuideLines();
    } else {
      this.coverGridLines = true;
      this.addCoverGuideLines();
    }
  }

  zoomIn () {
    this.project.cover.scale /= 0.9;
    if (this.coverGridLines) {
      this.removeCoverGuideLines();
    }
    this.zoomIt(1 / 0.9, true);
    if (this.coverGridLines) {
      this.addCoverGuideLines();
    }
  }

  zoomTo ( scale: number ) {
    //  WARNING THIS ASSUMES THE CURRENT SCALE IS 1.0
    this.project.cover.scale = scale;
    if (this.coverGridLines) {
      this.removeCoverGuideLines();
    }
    this.zoomIt(scale, true);
    if (this.coverGridLines) {
      this.addCoverGuideLines();
    }
  }

  zoomOut () {
    this.project.cover.scale *= 0.9;
    if (this.coverGridLines) {
      this.removeCoverGuideLines();
    }
    this.zoomIt(0.9, true);
    if (this.coverGridLines) {
      this.addCoverGuideLines();
    }
  }

  zoomToFullScale () {
    const factor = 1 / this.project.cover.scale;
    this.project.cover.scale = 1.0;
    if (this.coverGridLines) {
      this.removeCoverGuideLines();
    }
    this.zoomIt(factor, true);
    if (this.coverGridLines) {
      this.addCoverGuideLines();
    }
  }
  zoomIt (factor, render) {
    this.canvas.setHeight(this.canvas.getHeight() * factor);
    this.canvas.setWidth(this.canvas.getWidth() * factor);
    if (this.canvas.backgroundImage) {
      // Need to this.project.cover.scale background images as well
      const bi = this.canvas.backgroundImage;
      bi.width = bi.width * factor;
      bi.height = bi.height * factor;
    }
    const objects = this.canvas.getObjects();
    for (const object of objects) {
      // if ( !isNaN( i )) {
      const scaleX = object.scaleX;
      const scaleY = object.scaleY;
      const left = object.left;
      const top = object.top;

      const tempScaleX = scaleX * factor;
      const tempScaleY = scaleY * factor;
      const tempLeft = left * factor;
      const tempTop = top * factor;

      object.scaleX = tempScaleX;
      object.scaleY = tempScaleY;
      object.left = tempLeft;
      object.top = tempTop;

      try {
        object.setCoords();
      } catch (err) {
        let xx = 0;
        xx++;
      }
    }
    if (render) {
      this.canvas.renderAll();
    }
    this.canvas.calcOffset();
  }

  removeFromArray(array, value) {
    const index = array.indexOf(value);
    if (index !== -1) {
      array.splice(index, 1);
    }
    return array;
  }

  // orderObjects() {
  //   const objects = this.canvas.getObjects();
  //   console.log('orderObjects');
    //
    // // Work from the end to the front moving objects to earlier that are out of order
    // let indexOfNextLaterNonCropLine = -1;
    // for (let i = objects.length - 1; i >= 0; i--) {
    //   if (objects[i].orderId && objects[i].timestamp) { // Ignore crop lines
    //     if ( indexOfNextLaterNonCropLine !== -1 ) {
    //       const object = objects[indexOfNextLaterNonCropLine];
    //       if ( object.orderId < objects[i].orderId ) {
    //         if ( object.getType() === 'image') {
    //           this.removeFromArray(this.canvas._objects, object);
    //           let j = 0;
    //           for (; j < i && object[j].orderId < object.orderId; j++) {
    //           }
    //           this.canvas._objects.splice(j, 0, object);
    //           i++;
    //         } else {
    //           console.log('This should not happen because only images should be out of order:' + i);
    //         }
    //       }
    //     }
    //     indexOfNextLaterNonCropLine = i;
    //   }
    // }

    //
    //
    // const duplicatesToDelete = [];
    // for (let i = 0; i < objects.length; i++) {
    //   const object = objects[i];
    //   if ( object.orderId && object.timestamp ) { // Ignore crop lines
    //     if ( object.orderId === prevOrderId ) { // If the orderId is the same it is a duplicate
    //       if ( object.timestamp >= prevTimestamp ) { // Remove the duplicate with the earliest timestamp
    //         duplicatesToDelete.push(objects[i - 1]);
    //       } else if ( object.timestamp <= prevTimestamp ) {
    //         duplicatesToDelete.push(object);
    //       }
    //     }
    //     if ( object.orderId < prevOrderId ) {
    //       outOfOrder = true;
    //     }
    //     prevOrderId = object.orderId;
    //     prevTimestamp = object.timestamp;
    //   }
    // }
    //
    // for ( const object of duplicatesToDelete ) {
    //   this.canvas.remove(object);
    // }
    //
    // if ( outOfOrder ) {
    //   // Get a fresh list that does not include the duplicates
    //   const objects2 = this.canvas.getObjects();
    //   const objects3 = [];
    //   for (const object of objects2) {
    //     objects3.push(object);
    //   }
    //
    //   // Remove all of the objects and add them back in the correct order
    //   for ( const object of objects2 ) {
    //     this.canvas.remove(object);
    //   }
    //
    //   // Sort the objects
    //   objects3.sort( (x, y ) => {
    //     if ( x && y && x.orderId && y.orderId ) {
    //       return x.orderId - y.orderId;
    //     }
    //     return 0;
    //   });
    //
    //   // Add the objects back in in order
    //   for ( const object of objects3 ) {
    //     this.canvas._objects.push(object);
    //   }
    //   // this.canvas.requestRenderAll();
    // }




    // if ( object )
    //   object.setCoords();

    // objects.sort( (x, y ) => {
    //   if ( x && y && x.orderId && y.orderId ) {
    //     if ( x.orderId === y.orderId ) {
    //       if (x.timestamp < y.timestamp) {
    //         x.opacity = 0;
    //         duplicatesToDelete.push(x);
    //       } else if (x.timestamp === y.timestamp) {
    //         duplicatesToDelete.push(x);
    //       } else {
    //         duplicatesToDelete.push(y);
    //       }
    //       return 0;
    //     }
    //     return x.orderId - y.orderId;
    //   }
    //   return 0;
    // });
    // for ( const object of duplicatesToDelete ) {
    //   this.canvas.remove(object);
    // }
    // for ( const object of objects ) {
    //   object.setCoords();
    // }
    // this.canvas.calcOffset();
    // this.canvas.renderAll();
    // this.canvas.calcOffset();
  // }

  // orderObjects() {
  //   const objects = this.canvas.getObjects();
  //   const duplicatesToDelete = [];
  //
  //   let outOfOrder = false;
  //   let prevOrderId = 0;
  //   let prevTimestamp = 0;
  //   for (let i = 0; i < objects.length; i++) {
  //     const object = objects[i];
  //     if ( object.orderId && object.timestamp ) { // Ignore crop lines
  //       if ( object.orderId === prevOrderId ) { // If the orderId is the same it is a duplicate
  //         if ( object.timestamp >= prevTimestamp ) { // Remove the duplicate with the earliest timestamp
  //           duplicatesToDelete.push(objects[i - 1]);
  //         } else if ( object.timestamp <= prevTimestamp ) {
  //           duplicatesToDelete.push(object);
  //         }
  //       }
  //       if ( object.orderId < prevOrderId ) {
  //         outOfOrder = true;
  //       }
  //       prevOrderId = object.orderId;
  //       prevTimestamp = object.timestamp;
  //     }
  //   }
  //
  //   for ( const object of duplicatesToDelete ) {
  //     this.canvas.remove(object);
  //   }
  //
  //   if ( outOfOrder ) {
  //     // Get a fresh list that does not include the duplicates
  //     const objects2 = this.canvas.getObjects();
  //     const objects3 = [];
  //     for (const object of objects2) {
  //       objects3.push(object);
  //     }
  //
  //     // Remove all of the objects and add them back in the correct order
  //     for ( const object of objects2 ) {
  //       this.canvas.remove(object);
  //     }
  //
  //     // Sort the objects
  //     objects3.sort( (x, y ) => {
  //       if ( x && y && x.orderId && y.orderId ) {
  //         return x.orderId - y.orderId;
  //       }
  //       return 0;
  //     });
  //
  //     // Add the objects back in in order
  //     for ( const object of objects3 ) {
  //       this.canvas._objects.push(object);
  //     }
  //     // this.canvas.requestRenderAll();
  //   }
  //
  //
  //
  //
  //   // if ( object )
  //   //   object.setCoords();
  //
  //   // objects.sort( (x, y ) => {
  //   //   if ( x && y && x.orderId && y.orderId ) {
  //   //     if ( x.orderId === y.orderId ) {
  //   //       if (x.timestamp < y.timestamp) {
  //   //         x.opacity = 0;
  //   //         duplicatesToDelete.push(x);
  //   //       } else if (x.timestamp === y.timestamp) {
  //   //         duplicatesToDelete.push(x);
  //   //       } else {
  //   //         duplicatesToDelete.push(y);
  //   //       }
  //   //       return 0;
  //   //     }
  //   //     return x.orderId - y.orderId;
  //   //   }
  //   //   return 0;
  //   // });
  //   // for ( const object of duplicatesToDelete ) {
  //   //   this.canvas.remove(object);
  //   // }
  //   // for ( const object of objects ) {
  //   //   object.setCoords();
  //   // }
  //   // this.canvas.calcOffset();
  //   // this.canvas.renderAll();
  //   // this.canvas.calcOffset();
  // }
  getType() {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return '';
    }
    return (object['type'] || '');

  }

  getImageKey(): string {
    const object = this.canvas.getActiveObject();
    if (!object || object['type'] !== 'image' ) {
      return '';
    }
    return object.imageKey;
  }

  setImageOption(imageKey, horizontalAdjustment, verticalAdjustment, scaleAdjustment) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';

    if ( this.project.cover ) {
      if ( imageKey ) {
        this.project.cover.addImage(imageKey, role);
        this.setOverridePropertyNumber('horizontalAdjustment', horizontalAdjustment);
        this.setOverridePropertyNumber('vertocalAdjustment', verticalAdjustment);
        this.setOverridePropertyNumber('scaleAdjustment', scaleAdjustment);
      } else {
        this.project.cover.removeImage('', role);
      }
    }
  }

  setImageSrc(imageKey: string, imageUrl: string) {
    const object = this.canvas.getActiveObject();
    if (!object || object['type'] !== 'image' ) {
      return '';
    }
    object['imageKey'] = imageKey;
    object['imageKeyAdjustment'] = imageKey;

    // object['src'] = imageUrl;
    object.setSrc(imageUrl, _ => {
      console.log('callback from image set src in CanvasManager');
    });
    this.refreshObject(object);

    // object.loadImage(imageUrl);
    this.canvas.calcOffset();
    this.canvas.renderAll();

    if ( this.project && this.canvas && this.projectSaver ) {
      this.projectSaver.saveProjectAndCanvas(this, this.project, this.canvas);
    }

  }

  getRole() {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return '';
    }
    return (object['role'] || '');

  }

  getRoleColor(): string {
    const role = this.getRole();
    if ( role ) {
      const themeItem = this.project.cover.coverTheme.getCoverThemeItemSetting(role);
      if ( themeItem) {
        if ( themeItem.hasFont() ) {
          return themeItem.getFontColor();
        } else {
          return themeItem.getColor();
        }
      }
    }
    return '';
  }

  getRoleFontFamily() {
    const role = this.getRole();
    if ( role ) {
      const themeItem = this.project.cover.coverTheme.getCoverThemeItemSetting(role);
      if ( themeItem) {
        return themeItem.getFontFamily();
      }
    }
    return '';
  }

// Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  // Start functions to manipulate the canvas
  setOverridePropertyObject (property: string, value: Object) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      cover.setImagePropertyObject(role, property, value);
    }
    // object.setCoords();
    // this.refreshObject(object);
    // this.canvas.renderAll();
  }

  clearOverrideProperty (property: string) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      cover.clearImageProperty(role, property);
    }
    if ( this.project && this.canvas && this.projectSaver ) {
      this.projectSaver.saveProjectAndCanvas(this, this.project, this.canvas);
    }
    object.setCoords();
    this.refreshObject(object);
  }

  setOverridePropertyString (property: string, value: string) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      cover.setImagePropertyString(role, property, value);
    }
    if ( this.project && this.canvas && this.projectSaver ) {
      this.projectSaver.saveProjectAndCanvas(this, this.project, this.canvas);
    }
    object.setCoords();
    this.refreshObject(object);
    // this.canvas.renderAll();
  }

  setOverridePropertyNumber (property: string, value: number) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      cover.setImagePropertyNumber(role, property, value);
    }
    object.setCoords();
    this.refreshObject(object);
    // this.canvas.renderAll();
  }

  getOverridePropertyNumber(property: string, defaultValue: number): number {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return undefined;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      return cover.getImagePropertyNumber(role, property, defaultValue);
    }
    return  undefined;
  }
  setOverridePropertyBoolean (property: string, value: boolean) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      cover.setImagePropertyBoolean(role, property, value);
    }
  }

  getOverridePropertyBoolean(property: string, defaultValue: boolean): boolean {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return undefined;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      return cover.getImagePropertyBoolean(role, property, defaultValue);
    }
    return  undefined;
  }
  getOverridePropertyString(property: string, defaultValue: string): string {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return undefined;
    }
    const role = object['role'] || '';
    const cover = this.project.cover;
    if ( cover && role && property ) {
      return cover.getImagePropertyString(role, property, defaultValue);
    }
    return  undefined;
  }


  setEditText(value: boolean) {
    const object = this.canvas.getActiveObject();
    if ( object ) {
      object.isEditing = value;
    }
  }

  getEditText(): boolean {
    const object = this.canvas.getActiveObject();
    if ( object && object.isEditing ) {
      return true;
    }
    return false;
  }
  getActiveStyle (styleName, object?: any) {
    object = object || this.canvas.getActiveObject();
    if (!object) {
      return '';
    }
    // Changed by Todd to allow for changing of properties of the WHOLE object not just the selected area when a text area is being edited by a user 10/25/2017
    // return (object.getSelectionStyles && object.isEditing)
    //  ? (object.getSelectionStyles()[styleName] || '')
    //  : (object[styleName] || '');
    return (object[styleName] || '');
  }

  setActiveStyle (styleName, value, object?: any) {
    object = object || this.canvas.getActiveObject();
    if (!object) {
      return;
    }

    // Changed by Todd to allow for changing of properties of the WHOLE object not just the selected area when a text area is being edited by a user 10/25/2017
    if (object.setSelectionStyles && object.isEditing) {
     const style = { };
     style[styleName] = value;
     object.setSelectionStyles(style);
     object.setCoords();
    } else {
      object.set(styleName, value);
    }
    if ( this.project && this.canvas && this.projectSaver ) {
      object.setCoords();
      if ( object && this.getType() === 'textbox') {
        if (object.text === '') {
          object.text = ' ';
          object.notext = true;
        } else {
          object.notext = false;
        }
        if (object.text === '') {
          object.text = ' ';
          object.notext = true;
        } else {
          object.notext = false;
        }
        this.setOverridePropertyString('text', object.text);
        this.setOverridePropertyString('notext', object.notext);
        if (object.styles) {
          this.setOverridePropertyObject('textStyles', object.styles);
        } else {
          //                this_.setOverridePropertyObject('textStyles', {});
        }
        this.projectSaver.saveProjectAndCanvas(this, this.project, this.canvas);
      }
    }
    object.setCoords();
    this.refreshObject(object);
    this.canvas.renderAll();
  }

  // Some utility functions
  getRandomInt (min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
  }

  getRandomLeftTop () {
    const offset = 50;
    return {
      left: fabric.util.getRandomInt(0 + offset, 700 - offset), top: fabric.util.getRandomInt(0 + offset, 500 - offset)
    };
  }

  getRandomColor () {
    return '333333';
  }

  capitalize (value: string): string {
    return value;
  }

  // End some utility functions

  getActiveProp (name) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return '';
    }

    return object[name] || '';
  }

  setActiveProp (name, value) {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return;
    }
    object.set(name, value).setCoords();
    this.canvas.renderAll();
  }

  hasTextStylesWithinActiveObject(): boolean {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return false;
    }

    if (object.styles && Object.keys(object.styles).length > 0 ) {
      return true;
    }
    return false;
  }

  clearTextStylesWithinActiveObject() {
    const object = this.canvas.getActiveObject();
    if (!object) {
      return false;
    }

    if (object.styles && Object.keys(object.styles).length > 0 ) {
      object.styles = {};
    }
    this.refreshObject(object);
    this.canvas.renderAll();
  }

  hasRealTextStylesWithinObject(object?: any): boolean {
    object = object || this.canvas.getActiveObject();
    if (!object) {
      return false;
    }

    if (object.styles) {
      const keys = Object.keys(object.styles);
      if (keys.length > 0 ) {
        for ( const key of keys) {
          const o = object.styles[key];
          const ks = Object.keys(o);
          if (o && ks.length > 0 ) {
            for ( const k of ks) {
              const p = o[k];
              if (p && Object.keys(p).length > 0 ) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }

  cleanTextStylesWithinActiveObject(object?: any) {
    object = object || this.canvas.getActiveObject();
    if (!object) {
      return;
    }

    if (object.styles && Object.keys(object.styles).length > 0 && !this.hasRealTextStylesWithinObject(object) ) {
      // object.styles = {};
    }
    this.refreshObject(object);
    this.canvas.renderAll();
  }

  getOpacity () {
    let opacity = Number(this.getActiveStyle('opacity'));
    if ( opacity === 0 ) {
      return opacity;
    }
    if ( opacity ) {
      if ( opacity < 0 ) {
        opacity = 0;
      }
      if ( opacity > 1 ) {
        opacity = 1;
      }
      return opacity;
    } else {
      return 1.0;
    }
  }



  setOpacity (value: number) {
    if ( value < 0 ) {
      value = 0;
    }
    if ( value > 1 ) {
      value = 1;
    }
    if ( value >= 0 && value <= 1.0 ) {
      this.setActiveStyle('opacity', value);
    } else {
      console.log('Tried to set opacity to:' + value);
    }


  }

  getOpacityAdjustment(): number {
    return Number(this.getActiveStyle('opacity'));
  }

  setOpacityAdjustment(value: number) {
    this.setOverridePropertyNumber('opacity', value);
    this.setOpacity(value);
  }


  getFill () {
    return this.getActiveStyle('fill');
  }

  setFill (value) {
    this.setActiveStyle('fill', value);
  }

  isBold () {
    return this.getActiveStyle('fontWeight') === 'bold';
  }

  toggleBold () {
    let fontWeight = this.getActiveStyle('fontWeight');
    if (fontWeight || fontWeight.length === 0) {
      fontWeight = this.getActiveStyle('fontWeight');
    }
    if (fontWeight === '100' || fontWeight === 'lighter') {
      fontWeight = '400';
    } else if (fontWeight === '200') {
      fontWeight = '300';
    } else if (fontWeight === '300') {
      fontWeight = '400';
    } else if (fontWeight === '400' || fontWeight === 'normal') {
      fontWeight = '700';
    } else if (fontWeight === '500') {
      fontWeight = '600';
    } else if (fontWeight === '600') {
      fontWeight = '700';
    } else if (fontWeight === '700' || fontWeight === 'bold') {
      fontWeight = '900';
    } else if (fontWeight === '800') {
      fontWeight = '900';
    } else if (fontWeight === '900' || fontWeight === 'bolder') {
      fontWeight = '100';
    }
    this.setOverridePropertyString('fontWeight', fontWeight);
    this.setActiveStyle('fontWeight', fontWeight);
  }

  isItalic () {
    return this.getActiveStyle('fontStyle') === 'italic';
  }

  toggleItalic () {
    let fontStyleAdj = this.getActiveStyle('fontStyle');
    if (fontStyleAdj === 'italic') {
      fontStyleAdj = 'normal';
    } else if (fontStyleAdj === 'normal') {
      fontStyleAdj = 'italic';
    }
    this.setActiveStyle('fontStyle', fontStyleAdj);
  }

  isUnderline () {
    return this.getActiveStyle('textDecoration').indexOf('underline') > -1;
  }

  toggleUnderline () {
    const value = this.isUnderline() ? this.getActiveStyle('textDecoration').replace('underline', '') : (this.getActiveStyle('textDecoration') + ' underline');
    this.setActiveStyle('textDecoration', value);
  }

  isLinethrough () {
    return this.getActiveStyle('textDecoration').indexOf('line-through') > -1;
  }

  toggleLinethrough () {
    const value = this.isLinethrough() ? this.getActiveStyle('textDecoration').replace('line-through', '') : (this.getActiveStyle('textDecoration') + ' line-through');

    this.setActiveStyle('textDecoration', value);
  }

  isOverline () {
    return this.getActiveStyle('textDecoration').indexOf('overline') > -1;
  }

  toggleOverline () {
    const value = this.isOverline() ? this.getActiveStyle('textDecoration').replace('overline', '') : (this.getActiveStyle('textDecoration') + ' overline');

    this.setActiveStyle('textDecoration', value);
  }

  getText () {
    return this.getActiveProp('text');
  }

  setText (value) {
    this.setActiveProp('text', value);
  }


  isTextAlignLeft () {
    if (this.getActiveProp('textAlign') === "left") {
      return true;
    }
    return false;
  }

  setTextAlignLeft (value) {
    this.setActiveProp('textAlign', 'left');
  }

  isTextAlignRight () {
    if (this.getActiveProp('textAlign') === "right") {
      return true;
    }
    return false;
  }

  setTextAlignRight (value) {
    this.setActiveProp('textAlign', 'right');
  }

  isTextAlignCenter () {
    if (this.getActiveProp('textAlign') === "center") {
      return true;
    }
    return false;
  }

  setTextAlignCenter () {
    this.setActiveProp('textAlign', 'center');
  }

  isTextAlignJustify () {
    if (this.getActiveProp('textAlign') === "justify") {
      return true;
    }
    return false;
  }


  getDebug(): string {
    if ( this.canvas.getActiveObject() ) {
      let value = JSON.stringify(this.canvas.getActiveObject().toJSON());
      const additions = this.project.cover.imagePropertiesByRole[this.getRole()];
      if ( additions ) {
        value += JSON.stringify(additions);
      }
      console.log(value);
      return value;
    }
    return '';
  }
  setTextAlignJustify () {
    this.setActiveProp('textAlign', 'justify');
  }

  getTextAlign () {
    return this.capitalize(this.getActiveProp('textAlign'));
  }

  setTextAlign (value) {
    this.setActiveProp('textAlign', value.toLowerCase());
  }

  getFontFamily () {
    return this.getActiveProp('fontFamily').toLowerCase();
  }

  setFontFamily (value) {
    this.setActiveProp('fontFamily', value.toLowerCase());
  }

  getFontFamilySelectedText () {
    return this.getActiveStyle('fontFamily');
  }

  setFontFamilySelectedText (value) {
    this.setActiveStyle('fontFamily', value);
  }

  getTextColor () {
    return this.getActiveProp('fill');
  }

  setTextColor (value) {
    this.setActiveProp('fill', value);
  }

  getBgColor () {
    return this.getActiveProp('backgroundColor');
  }

  setBgColor (value) {
    this.setActiveProp('backgroundColor', value);
  }

  getTextBgColor () {
    return this.getActiveProp('textBackgroundColor');
  }

  setTextBgColor (value) {
    this.setActiveProp('textBackgroundColor', value);
  }

  getStroke () {
    return this.getActiveStyle('stroke');
  }

  setStroke (value) {
    this.setActiveStyle('stroke', value);
  }

  getStrokeWidth () {
    return this.getActiveStyle('strokeWidth');
  }

  setStrokeWidth (value) {
    this.setActiveStyle('strokeWidth', parseInt(value, 10));
  }

  getFontSize () {
    return this.getActiveStyle('fontSize');
  }

  setFontSize (value) {
    this.setActiveStyle('fontSize', parseInt(value, 10));
  }

  getLineHeight () {
    return this.getActiveStyle('lineHeight');
  }

  setLineHeight (value) {
    this.setActiveStyle('lineHeight', parseFloat(value));
  }


  getCharSpacing () {
    return this.getActiveStyle('charSpacing');
  }

  setCharSpacing (value) {
    this.setActiveStyle('charSpacing', value);
  }

  isHidden() {
    return this.getOverridePropertyBoolean('hidden', undefined);
  }

  setHidden(hide: boolean ) {
    const object = this.getSelected();
    this.setOverridePropertyBoolean('hidden', hide);
    this.refreshObject(this.getSelected());
    this.canvas.calcOffset();
    this.canvas.renderAll();
  }


  getBold () {
    return this.getActiveStyle('fontWeight');
  }

  setBold (value) {
    this.setActiveStyle('fontWeight', value ? 'bold' : '');
  }

  getCanvasBgColor () {
    return this.canvas.backgroundColor;
  }

  setCanvasBgColor (value) {
    this.canvas.backgroundColor = value;
    this.canvas.renderAll();
  }

  getMovement(): string {
    return this.getOverridePropertyString('movement', undefined);
  }

  shiftUp1Percent() {
    let adj = this.getOverridePropertyNumber('verticalAdjustment', undefined);
    if (adj) {
      adj = Number(adj) + Number(0.01);
    } else {
      adj = Number(1.01);
    }
    this.setOverridePropertyNumber('verticalAdjustment', adj);
  }

  shiftDown1Percent() {
    let adj = this.getOverridePropertyNumber('verticalAdjustment', undefined);
    if (adj) {
      adj = Number(adj) - Number(0.01);
    } else {
      adj = Number(0.99);
    }
    this.setOverridePropertyNumber('verticalAdjustment', adj);
  }

  shiftLeft1Percent() {
    let adj = this.getOverridePropertyNumber('horizontalAdjustment', undefined);
    if (adj) {
      adj = Number(adj) - Number(0.01);
    } else {
      adj = Number(0.99);
    }
    this.setOverridePropertyNumber('horizontalAdjustment', adj);
  }
  shiftRight1Percent() {
    let adj = this.getOverridePropertyNumber('horizontalAdjustment', undefined);
    if (adj) {
      adj = Number(adj) + Number(0.01);
    } else {
      adj = Number(1.01);
    }
    this.setOverridePropertyNumber('horizontalAdjustment', adj);
  }
  setScaleAdjustment(value: number) {
    this.setOverridePropertyNumber('scaleAdjustment', value);
  }
  getScaleAdjustment(): number {
    return this.getOverridePropertyNumber('scaleAdjustment', 1);
  }

  decreaseScale1Percent() {
    let adj = this.getOverridePropertyNumber('scaleAdjustment', undefined);
    if (adj) {
      adj = Number(adj) - Number(0.01);
    } else {
      adj = Number(0.99);
    }
    this.setOverridePropertyNumber('scaleAdjustment', adj);
  }
  increaseScale1Percent() {
    let adj = this.getOverridePropertyNumber('scaleAdjustment', undefined);
    if (adj) {
      adj = Number(adj) + Number(0.01);
    } else {
      adj = Number(1.01);
    }
    this.setOverridePropertyNumber('scaleAdjustment', adj);
  }

  addRect () {
    this.canvas.add(new fabric.Rect({
      left: this.getRandomInt(50 * this.project.cover.scale, 400 * this.project.cover.scale), top: this.getRandomInt(50 * this.project.cover.scale, 400 * this.project.cover.scale), preserveObjectStacking: true, fill: 'black', width: 50 * this.project.cover.scale, height: 50 * this.project.cover.scale, opacity: 1.0
    }));
  }

  addCircle () {
    this.canvas.add(new fabric.Circle({
      left: this.getRandomInt(50 * this.project.cover.scale, 400 * this.project.cover.scale), top: this.getRandomInt(50 * this.project.cover.scale, 400 * this.project.cover.scale), preserveObjectStacking: true, fill: 'black', radius: 50 * this.project.cover.scale, opacity: 1.0
    }));
  }

  // zoomIn() {
  //    this.project.cover.scale /= 0.9;
  //    this.zoomIt(1 / 0.9, true);
  //    this.setCoverEditorDisplayWidth();
  //    if (this.guidesAdded) {
  //      this.removeCoverGuideLines();
  //      this.addCoverGuideLines();
  //    }
  //  };
  //
  // zoomOut() {
  //    this.project.cover.scale *= 0.9;
  //    this.zoomIt(0.9, true);
  //    this.setCoverEditorDisplayWidth();
  //    if (this.guidesAdded) {
  //      this.removeCoverGuideLines();
  //      this.addCoverGuideLines();
  //    }
  //  };

  toggleGuides () {
    if (this.guidesAdded) {
      this.removeCoverGuideLines();
      this.guidesAdded = false;
    } else {
      this.addCoverGuideLines();
      this.guidesAdded = true;
    }
  }

  addTriangle () {

    this.canvas.add(new fabric.Triangle({
      left: this.getRandomInt(350, 400), top: this.getRandomInt(350, 400), preserveObjectStacking: true, fill: 'black', width: 50, height: 50, opacity: 0.8
    }));
  }

  addLine () {

    this.canvas.add(new fabric.Line([0, 0, 200, 0], {
      left: this.getRandomInt(50, 400), top: this.getRandomInt(50, 400), preserveObjectStacking: true, stroke: 'black'
    }));
  }

  addPolygon () {

    this.canvas.add(new fabric.Polygon([{x: 185, y: 0}, {x: 250, y: 100}, {x: 385, y: 170}, {x: 0, y: 245}], {
      left: 100, top: 100, fill: 'black'
    }));
  }

  addText () {
    const text = 'Text';

    const textSample = new fabric.Text(text, {
      left: this.getRandomInt(50 * this.project.cover.scale, 100 * this.project.cover.scale),
      top: this.getRandomInt(50 * this.project.cover.scale, 100 * this.project.cover.scale),
      preserveObjectStacking: true,
      fontFamily: 'helvetica',
      angle: 0,
      fill: 'black',
      scaleX: this.project.cover.scale,
      scaleY: this.project.cover.scale,
      fontWeight: '',
      originX: 'left',
      hasRotatingPoint: true,
      centerTransform: true
    });

    this.canvas.add(textSample);
  }

  addTextbox () {
    const text = 'Text';

    const textSample = new fabric.Textbox(text, {
      fontSize: 20,
      left: this.getRandomInt(50 * this.project.cover.scale, 100 * this.project.cover.scale),
      top: this.getRandomInt(50 * this.project.cover.scale, 100 * this.project.cover.scale),
      scaleX: this.project.cover.scale,
      scaleY: this.project.cover.scale,
      preserveObjectStacking: true,
      fontFamily: 'helvetica',
      angle: 0,
      fill: 'black',
      fontWeight: '',
      originX: 'left',
      width: 300,
      hasRotatingPoint: true,
      centerTransform: true
    });

    this.canvas.add(textSample);
  }

  addIText () {
    const text = 'Text';

    const textSample = new fabric.IText(text, {
      left: this.getRandomInt(350, 400),
      top: this.getRandomInt(350, 400),
      preserveObjectStacking: true,
      fontFamily: 'helvetica',
      angle: 0,
      fill: 'black',
      scaleX: 0.5,
      scaleY: 0.5,
      fontWeight: '',
      originX: 'left',
      hasRotatingPoint: true,
      centerTransform: true
    });

    this.canvas.add(textSample);
  }

  // We don't seem to need this
  // const addShape(shapeName) {
  //
  //   console.log('adding shape', shapeName);
  //
  //   const coord = this.getRandomLeftTop();
  //
  //   fabric.loadSVGFromURL('/images/' + shapeName + '.svg', function (objects, options) {
  //
  //     const loadedObject = fabric.util.groupSVGElements(objects, options);
  //
  //     loadedObject.set({
  //       left: coord.left, top: coord.top, angle: 0
  //     })
  //       .setCoords();
  //
  //     this.canvas.add(loadedObject);
  //   });
  // };
  //
  // maybeLoadShape(e) {
  //   const $el = $(e.target).closest('button.shape');
  //   if (!$el[0]) {
  //     return;
  //   }
  //
  //   const ID = $el.prop('ID'), match;
  //   if ( match = /\d+$/.exec(ID)) {
  //     addShape(match[0]);
  //   }
  // };

  addImageLocal (imageName, minScale, maxScale) {
    const coord = this.getRandomLeftTop();

    const cnvs = this.canvas;
    fabric.Image.fromURL(imageName, function (image) {

      image.set({
        left: coord.left, top: coord.top, preserveObjectStacking: true, angle: 0
      })
        .scale(0.5)
        .setCoords();

      cnvs.add(image);
    });
  }

  addImage (image) {
    this.addImageLocal(image, 0.3, 0.6);
  }

  // confirmClear () {
  //   if (confirm('Are you sure?')) {
  //     this.canvas.clear();
  //     this.project.cover.clearImages();
  //   }
  // }

  // rasterize () {
  //   if (!fabric.Canvas.supports('toDataURL')) {
  //     alert('This browser doesn\'t provide means to serialize canvas to an image');
  //   } else {
  //     _window().open(this.canvas.toDataURL('png'));
  //   }
  // }
  //
  // rasterizeSVG () {
  //   _window().open('data:image/svg+xml;utf8,' + encodeURIComponent(this.canvas.toSVG()));
  // }

  rasterizeJSON () {
    this.setConsoleJSON(JSON.stringify(this.canvas));
  }

  getSelected () {
    return this.canvas.getActiveObject();
  }

  removeSelected () {
    const activeObject = this.canvas.getActiveObject();
    const activeGroup = this.canvas.getActiveGroup();

    if (activeGroup) {
      const objectsInGroup = activeGroup.getObjects();
      this.canvas.discardActiveGroup();
      objectsInGroup.forEach(function (object) {
        this.canvas.remove(object);
      });
    } else if (activeObject) {
      this.canvas.remove(activeObject);
    }
  }

  getHorizontalLock () {
    return this.getActiveProp('lockMovementX');
  }

  setHorizontalLock (value) {
    this.setActiveProp('lockMovementX', value);
  }

  getVerticalLock () {
    return this.getActiveProp('lockMovementY');
  }

  setVerticalLock (value) {
    this.setActiveProp('lockMovementY', value);
  }

  getScaleLockX () {
    return this.getActiveProp('lockScalingX');
  }

  setScaleLockX (value) {
    this.setActiveProp('lockScalingX', value);
  }

  getScaleLockY () {
    return this.getActiveProp('lockScalingY');
  }

  setScaleLockY (value) {
    this.setActiveProp('lockScalingY', value);
  }

  getRotationLock () {
    return this.getActiveProp('lockRotation');
  }

  setRotationLock (value) {
    this.setActiveProp('lockRotation', value);
  }

  getOriginX () {
    return this.getActiveProp('originX');
  }

  setOriginX (value) {
    this.setActiveProp('originX', value);
  }

  getOriginY () {
    return this.getActiveProp('originY');
  }

  setOriginY (value) {
    this.setActiveProp('originY', value);
  }

  getObjectCaching () {
    return this.getActiveProp('objectCaching');
  }

  setObjectCaching (value) {
    return this.setActiveProp('objectCaching', value);
  }

  getNoScaleCache () {
    return this.getActiveProp('noScaleCache');
  }

  setNoScaleCache (value) {
    return this.setActiveProp('noScaleCache', value);
  }

  getTransparentCorners () {
    return this.getActiveProp('transparentCorners');
  }

  setTransparentCorners (value) {
    return this.setActiveProp('transparentCorners', value);
  }

  getHasBorders () {
    return this.getActiveProp('hasBorders');
  }

  setHasBorders (value) {
    return this.setActiveProp('hasBorders', value);
  }

  getHasControls () {
    return this.getActiveProp('hasControls');
  }

  setHasControls (value) {
    return this.setActiveProp('hasControls', value);
  }

  sendBackwards () {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      this.canvas.sendBackwards(activeObject);
    }
  }

  sendToBack () {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      this.canvas.sendToBack(activeObject);
    }
  }

  bringForward () {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      this.canvas.bringForward(activeObject);
    }
  }

  bringToFront () {
    const activeObject = this.canvas.getActiveObject();
    if (activeObject) {
      this.canvas.bringToFront(activeObject);
    }
  }

  // This needs to pass in a pattern
  //  const pattern = new fabric.Pattern({
  //    source: '/images/image3.png', repeat: 'repeat'
  //  });
  //
  // patternify() {
  //    const obj = this.canvas.getActiveObject();
  //
  //    if (!obj) {
  //      return;
  //    }
  //
  //    if (obj.fill instanceof fabric.Pattern) {
  //      obj.set('fill', null);
  //    } else {
  //      if (obj instanceof fabric.PathGroup) {
  //        obj.getObjects().forEach(function (o) {
  //          o.set('fill', pattern);
  //        });
  //      } else {
  //        obj.set('fill', pattern);
  //      }
  //    }
  //    this.canvas.renderAll();
  //  }

  clip () {
    const obj = this.canvas.getActiveObject();
    if (!obj) {
      return;
    }

    if (obj.clipTo) {
      obj.clipTo = null;
    } else {
      const radius = obj.width < obj.height ? (obj.width / 2) : (obj.height / 2);
      obj.clipTo = function (ctx) {
        ctx.arc(0, 0, radius, 0, Math.PI * 2, true);
      };
    }
    this.canvas.renderAll();
  }

  shadowify () {
    const obj = this.canvas.getActiveObject();
    if (!obj) {
      return;
    }

    if (obj.shadow) {
      obj.shadow = null;
    } else {
      obj.setShadow({
        color: 'rgba(0,0,0,0.3)', blur: 10, offsetX: 10, offsetY: 10
      });
    }
    this.canvas.renderAll();
  }

  gradientify () {
    const obj = this.canvas.getActiveObject();
    if (!obj) {
      return;
    }

    obj.setGradient('fill', {
      x1: 0, y1: 0, x2: (this.getRandomInt(0, 1) ? 0 : obj.width), y2: (this.getRandomInt(0, 1) ? 0 : obj.height), colorStops: {
        0: '#' + this.getRandomColor(), 1: '#' + this.getRandomColor()
      }
    });
    this.canvas.renderAll();
  }


  execute () {
    if (!(/^\s+$/).test(this.consoleValue)) {
      // New code to be typescript compatible
      // eval(consoleValue);
      console.log("In fabric canvas executing: " + this.consoleValue);
      const myEval = eval;
      myEval(this.consoleValue);
    }
  }


  getConsoleJSON () {
    return this.consoleJSONValue;
  }

  setConsoleJSON (value) {
    this.consoleJSONValue = value;
  }

  getConsoleSVG () {
    return this.consoleSVGValue;
  }

  setConsoleSVG (value) {
    this.consoleSVGValue = value;
  }

  getConsole () {
    return this.consoleValue;
  }

  setConsole (value) {
    this.consoleValue = value;
  }

  loadSVGWithoutGrouping () {
    // _loadSVGWithoutGrouping(consoleSVGValue);
    fabric.loadSVGFromString(this.consoleSVGValue, function (objects) {
      this.canvas.add.apply(this.canvas, objects);
      this.canvas.renderAll();
    });
  }

  loadSVG () {
    // _loadSVG(consoleSVGValue);
    fabric.loadSVGFromString(this.consoleSVGValue, function (objects, options) {
      const obj = fabric.util.groupSVGElements(objects, options);
      this.canvas.add(obj).centerObject(obj).renderAll();
      obj.setCoords();
    });
  }

  // const _loadSVG(svg) {
  //   fabric.loadSVGFromString(svg, function (objects, options) {
  //     const obj = fabric.util.groupSVGElements(objects, options);
  //     this.canvas.add(obj).centerObject(obj).renderAll();
  //     obj.setCoords();
  //   });
  // };
  //
  // const _loadSVGWithoutGrouping(svg) {
  //   fabric.loadSVGFromString(svg, function (objects) {
  //     this.canvas.add.apply(this.canvas, objects);
  //     this.canvas.renderAll();
  //   });
  // };

  saveJSON () {
    // _saveJSON(JSON.stringify(this.canvas));
    this.setConsoleJSON(JSON.stringify(this.canvas));
  }

  // _saveJSON function (json) {
  //  setConsoleJSON(json);
  // };

  loadJSON () {
    // _loadJSON(consoleJSONValue);
    this.canvas.loadFromJSON(this.consoleJSONValue, function () {
      this.canvas.renderAll();
    });
  }

  // const _loadJSON(json) {
  //   this.canvas.loadFromJSON(json, function () {
  //     this.canvas.renderAll();
  //   });
  // };

  initCustomization () {
    // Not sure if we need these fonts
    // if (typeof Cufon !== 'undefined' && Cufon.fonts.delicious) {
    //   Cufon.fonts.delicious.offsetLeft = 75;
    //   Cufon.fonts.delicious.offsetTop = 25;
    // }

    if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
      fabric.Object.prototype.cornerSize = 30;
    }

    fabric.Object.prototype.transparentCorners = false;

    // if (document.location.search.indexOf('guidelines') > -1) {
    //   this.initCenteringGuidelines(this.canvas);
    //   this.initAligningGuidelines(this.canvas);
    // }
  }


  getPreserveObjectStacking () {
    return this.canvas.preserveObjectStacking;
  }

  setPreserveObjectStacking (value) {
    return this.canvas.preserveObjectStacking = value;
  }

  getFreeDrawingMode () {
    return this.canvas.isDrawingMode;
  }

  setFreeDrawingMode (value) {
    this.canvas.isDrawingMode = !!value;
    // $scope.$$phase || $scope.$digest();
  }

  getDrawingMode () {
    return this.freeDrawingMode;
  }

  // For this to work we need controls
  setDrawingMode (type) {
    this.freeDrawingMode = type;

    if (type === 'hline') {
      this.canvas.freeDrawingBrush = this.vLinePatternBrush;
    } else if (type === 'vline') {
      this.canvas.freeDrawingBrush = this.hLinePatternBrush;
    } else if (type === 'square') {
      this.canvas.freeDrawingBrush = this.squarePatternBrush;
    } else if (type === 'diamond') {
      this.canvas.freeDrawingBrush = this.diamondPatternBrush;
    } else if (type === 'texture') {
      this.canvas.freeDrawingBrush = this.texturePatternBrush;
    } else {
      this.canvas.freeDrawingBrush = new fabric[type + 'Brush'](this.canvas);
    }

    // $scope.$$phase || $scope.$digest();
  }

  getDrawingLineWidth () {
    if (this.canvas.freeDrawingBrush) {
      return this.canvas.freeDrawingBrush.width;
    }
  }

  setDrawingLineWidth (value) {
    if (this.canvas.freeDrawingBrush) {
      this.canvas.freeDrawingBrush.width = parseInt(value, 10) || 1;
    }
  }

  getDrawingLineColor () {
    if (this.canvas.freeDrawingBrush) {
      return this.canvas.freeDrawingBrush.color;
    }
  }

  setDrawingLineColor (value) {
    if (this.canvas.freeDrawingBrush) {
      this.canvas.freeDrawingBrush.color = value;
    }
  }

  getDrawingLineShadowWidth () {
    if (this.canvas.freeDrawingBrush && this.canvas.freeDrawingBrush.shadow) {
      return this.canvas.freeDrawingBrush.shadow.blur || 1;
    } else {
      return 0;
    }
  }

  setDrawingLineShadowWidth (value) {
    if (this.canvas.freeDrawingBrush) {
      const blur = parseInt(value, 10) || 1;
      if (blur > 0) {
        this.canvas.freeDrawingBrush.shadow = new fabric.Shadow({blur: blur, offsetX: 10, offsetY: 10});
      } else {
        this.canvas.freeDrawingBrush.shadow = null;
      }
    }
  }

  initBrushes () {
    if (!fabric.PatternBrush) {
      return;
    }

    this.initVLinePatternBrush();
    this.initHLinePatternBrush();
    this.initSquarePatternBrush();
    this.initDiamondPatternBrush();
    this.initImagePatternBrush();
  }

  initImagePatternBrush () {
    const img = new Image();
    img.src = '/assets/images/image4.png';

    this.texturePatternBrush = new fabric.PatternBrush(this.canvas);
    this.texturePatternBrush.source = img;
  }

  initDiamondPatternBrush () {
    this.diamondPatternBrush = new fabric.PatternBrush(this.canvas);
    this.diamondPatternBrush.getPatternSrc = function () {

      const squareWidth = 10, squareDistance = 5;
      const patternCanvas = fabric.document.createElement('canvas');
      const rect = new fabric.Rect({
        width: squareWidth, height: squareWidth, angle: 45, fill: this.color
      });

      const canvasWidth = rect.getBoundingRectWidth();

      patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
      rect.set({left: canvasWidth / 2, top: canvasWidth / 2});

      const ctx = patternCanvas.getContext('2d');
      rect.render(ctx);

      return patternCanvas;
    };
  }

  initSquarePatternBrush () {
    this.squarePatternBrush = new fabric.PatternBrush(this.canvas);
    this.squarePatternBrush.getPatternSrc = function () {

      const squareWidth = 10, squareDistance = 2;

      const patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
      const ctx = patternCanvas.getContext('2d');

      ctx.fillStyle = this.color;
      ctx.fillRect(0, 0, squareWidth, squareWidth);

      return patternCanvas;
    };
  }

  initVLinePatternBrush () {
    this.vLinePatternBrush = new fabric.PatternBrush(this.canvas);
    this.vLinePatternBrush.getPatternSrc = function () {

      const patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      const ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(0, 5);
      ctx.lineTo(10, 5);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };
  }

  initHLinePatternBrush () {
    this.hLinePatternBrush = new fabric.PatternBrush(this.canvas);
    this.hLinePatternBrush.getPatternSrc = function () {

      const patternCanvas = fabric.document.createElement('canvas');
      patternCanvas.width = patternCanvas.height = 10;
      const ctx = patternCanvas.getContext('2d');

      ctx.strokeStyle = this.color;
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(5, 0);
      ctx.lineTo(5, 10);
      ctx.closePath();
      ctx.stroke();

      return patternCanvas;
    };
  }

  // Methods to get info from the themeItem or from the current override values
  getThemeItem(): CoverThemeItemSetting {
    const role = this.getRole();
    if ( role ) {
      if ( this.project && this.project.cover ) {
        const coverTheme = this.project.cover.getCoverTheme();
        if ( coverTheme ) {
          return coverTheme.getCoverThemeItemSetting(role);
        }
      }
    }
    return undefined;
  }

  getCoverArea() {
    const themeItem = this.getThemeItem();
    if ( themeItem ) {
      return themeItem.getCoverArea();
    }
    return '';
  }
}

export class Controls {
  public middleTopControl: boolean;
  public middleBottomControl: boolean;
  public middleLeftControl: boolean;
  public middleRightControl: boolean;
  public bottomLeftControl: boolean;
  public bottomRightControl: boolean;
  public topLeftControl: boolean;
  public topRightControl: boolean;
  public rotationControl: boolean;
}

export class CanvasObjectProperties {
  public fontFamily: string;
  public objectCaching: boolean;
  public hasControls: boolean;
  public preserveObjectStacking: boolean;
  public lockMovementX: boolean;
  public lockMovementY: boolean;
  // public lockScalingX: boolean;
  // public lockScalingY: boolean;
  public originX: string;
  public originY: string;
  public angle: number;
  public fill: string;
  public background: string;
  public role: string;
  public opacity: number;
  public left: number;
  public right: number;
  public top: number;
  public bottom: number;
  public height: number;
  public width: number;
  public text: string;
  public notext: boolean;
  public radius: number;
  public scaleX: number;
  public scaleY: number;
  public selectable: boolean;
  // public styles: any;
  // public visible: boolean;
  public imageKey: string;
  public scaleAdjustment: number;
  public horizontalAdjustment: number;
  public verticalAdjustment: number;
  public movement: string;
  public positionFit: string;
  public textAlign: string;
  public fontWeight: string;
  public fontStyle: string;
  public charSpacing: number;
  public lineHeight: number;
  public fontSize: number;
  public orderId: number;
  public timestamp: number;
  // public editable: boolean;
}



